import { QueryClient } from '@tanstack/react-query'
import { createRootRoute, createRoute, createRouter, redirect, useMatchRoute } from '@tanstack/react-router'
import { isDoor } from './api/alarms'
import { isList } from './api/inventoree'
import { isList as isOpteemumList } from './api/opteemum'
import { isOverviewPage } from './api/overview'
import { isPage as isProactiviteePage, listOf as proactiviteeListOf } from './api/proactivitee'
import { isList as isSoftseeList, isPage as isSoftseePage, listOf } from './api/softsee'
import { isDiagnosticReportPage } from './api/settingsDiagnosticReports'
import { isGeneralTab } from './api/settingsGeneral'
import { isCompanyTab } from './api/settingsCompanies'
import { isContractTab } from './api/settingsContracts'
import { isUsersTab } from './api/settingsUsers'
import { isMyAccountTab } from './api/settingsMyAccount'
import { isLicensesTab } from './api/settingsLicenses'
import { isCustomersTab } from './api/settingsCustomers'
import { isServicesTab } from './api/settingsCustomerServices'
import { isInventoreeTab } from './api/settingsInventoree'
import { isOpteemumTab } from './api/settingsOpteemum'
import { isProactiviteeTab } from './api/settingsProactivitee'
import { isSoftseeTab } from './api/settingsSoftsee'
import { isSecuriteeTab } from './api/settingsSecuritee'
import { isPrinteengTab } from './api/settingsPrinteeng'
import { isProtecteeSettingsTab } from './api/settingsProtectee'
import { isSaveenergeeSettingsTab } from './api/settingsSaveenergee'
import { isProductiviteeSettingsTab } from './api/settingsProductivitee'
import { isChangeScope } from './api/admChanges'
import { ChangesPage } from './softsee/adm/ChangesPage'
import { DiscoveryDashboardPage } from './softsee/adm/DiscoveryDashboardPage'
import { PendingQueuePage } from './softsee/adm/PendingQueuePage'
import { ImpactPage } from './softsee/adm/ImpactPage'
import { ActivityPage } from './ai/ActivityPage'
import { SchedulesPage as AiSchedulesPage } from './ai/SchedulesPage'
import { ExposurePage } from './softsee/adm/ExposurePage'
import { ErrorsPage } from './softsee/adm/ErrorsPage'
import { ErrorDetailPage } from './softsee/adm/ErrorDetailPage'
import { CoveragePage } from './softsee/adm/CoveragePage'
import { RunDetailPage } from './softsee/adm/RunDetailPage'
import { RunsPage } from './softsee/adm/RunsPage'
import { DynamicReportsPage, type ReportsLocation } from './reports/ReportsPage'
import { SchedulesPage } from './softsee/adm/SchedulesPage'
import { SoftwareCategoriesPage } from './softsee/adm/SoftwareCategoriesPage'
import { SoftwarePendingPage } from './softsee/adm/SoftwarePendingPage'
import { MapPage } from './softsee/adm/MapPage'
import { WallboardsPage } from './softsee/adm/WallboardsPage'
import { WallboardPage } from './monitor/WallboardPage'
import { AlarmFleetPage } from './alarms/AlarmFleetPage'
import { DashboardPage } from './dashboard/DashboardPage'
import { DashboardWall } from './dashboard/DashboardWall'
import { DeviceListPage } from './inventoree/DeviceListPage'
import { DevicePage } from './inventoree/DevicePage'
import { InventoreeDashboardPage } from './inventoree/InventoreeDashboardPage'
import { ModuleBoardPage } from './dashboard/ModuleBoardPage'
import { moduleBoardQuery } from './api/moduleBoard'
import { DiscoveredPage } from './inventoree/DiscoveredPage'
import { EndpointPerformancePage } from './inventoree/EndpointPerformancePage'
import { InventoryMapPage } from './inventoree/InventoryMapPage'
import { ManagedPage } from './inventoree/ManagedPage'
import { PrintersPage } from './inventoree/PrintersPage'
import { ReportsPage } from './inventoree/ReportsPage'
import { SoftwareLicensesPage } from './inventoree/SoftwareLicensesPage'
import { UnassignedPage } from './inventoree/UnassignedPage'
import { UpgradesPage } from './inventoree/UpgradesPage'
import { ApplicationsPage as OpteemumApplicationsPage } from './opteemum/ApplicationsPage'
import { DeviceListPage as OpteemumDeviceListPage } from './opteemum/DeviceListPage'
import { DevicePage as OpteemumDevicePage } from './opteemum/DevicePage'
import { RemotePage } from './opteemum/RemotePage'
import { SchedulePage } from './opteemum/SchedulePage'
import { UnassignedPage as OpteemumUnassignedPage } from './opteemum/UnassignedPage'
import { AheadPage } from './overview/AheadPage'
import { DomainsPage } from './overview/DomainsPage'
import { CmdbListPage } from './cmdb/CmdbListPage'
import { ApplicationsPage } from './applications/ApplicationsPage'
import { ApplicationDetailPage } from './applications/ApplicationDetailPage'
import { ApplicationMapPage } from './applications/map/ApplicationMapPage'
import { VendorsPage as ApplicationVendorsPage } from './applications/vendors/VendorsPage'
import { MonthlyReportPage } from './applications/report/MonthlyReportPage'
import { CmdbRecordPage } from './cmdb/CmdbRecordPage'
import { ConnectionQualityFullPage, type CqFullSearch } from './devices/ConnectionQualityFullPage'
import { CmdbHealthPage } from './cmdb/CmdbHealthPage'
import { CmdbBaselinesPage } from './cmdb/CmdbBaselinesPage'
import { CmdbImportPage } from './cmdb/CmdbImportPage'
import { CmdbBaselineComparePage } from './cmdb/CmdbBaselineComparePage'
import { MaintenanceWindowsPage } from './maintenance/MaintenanceWindowsPage'
import { OnsitePresencePage } from './proactivitee/OnsitePresencePage'
import { MaintenanceCalendarPage } from './maintenance/MaintenanceCalendarPage'
import { MaintenanceDayPage } from './maintenance/MaintenanceDayPage'
import { ChangeProposalsPage } from './changes/ChangeProposalsPage'
import { ItilPage } from './overview/ItilPage'
import { Nis2Page } from './overview/Nis2Page'
import { ProblemsPage } from './overview/ProblemsPage'
import { ProblemPatternsPage } from './overview/ProblemPatternsPage'
import { ProblemRecordPage } from './overview/ProblemRecordPage'
import { TodayPage } from './overview/TodayPage'
import { GeneralSettingsPage } from './settings/general/GeneralSettingsPage'
import { CompanySettingsPage } from './settings/companies/CompanySettingsPage'
import { CiRulesPage } from './settings/ci_rules/CiRulesPage'
import { ContractsSettingsPage } from './settings/contracts/ContractsSettingsPage'
import { ContractTemplatesPage } from './settings/contracts/ContractTemplatesPage'
import { UserAccountsPage } from './settings/users/UserAccountsPage'
import { MyAccountPage } from './settings/my_account/MyAccountPage'
import { AgentInstallPage } from './settings/agent_install/AgentInstallPage'
import { FloorPlanPage, FloorPlansPage } from './floorplan/FloorPlansPage'
import { ConnectionQualitySettingsPage } from './settings/connection_quality/ConnectionQualitySettingsPage'
import { RemoteConnectPage } from './settings/remote_connect/RemoteConnectPage'
import { ApiIntegrationPage } from './settings/api_integration/ApiIntegrationPage'
import { WebhooksPage } from './settings/webhooks/WebhooksPage'
import { ApiLogPage } from './settings/api_integration/ApiLogPage'
import { AiAgentCompanyPage, AiAgentGlobalPage } from './settings/ai_agent/AiAgentSettingsPage'
import { LicensesSettingsPage } from './settings/licenses/LicensesSettingsPage'
import { CustomersSettingsPage } from './settings/customers/CustomersSettingsPage'
import { CustomerServicesPage } from './settings/customer_services/CustomerServicesPage'
import { ChangeLogSettingsPage } from './settings/change_log/ChangeLogSettingsPage'
import { ContactsSettingsPage } from './settings/contacts/ContactsSettingsPage'
import { AuthenticationSettingsPage, isAuthSection } from './settings/authentication/AuthenticationSettingsPage'
import { AuthGroupRulesPage } from './settings/authentication/AuthGroupRulesPage'
import { PassSafePage } from './settings/pass_safe/PassSafePage'
import { DownloadAgentPage } from './settings/download_agent/DownloadAgentPage'
import { AgentReleasesPage } from './settings/agent_releases/AgentReleasesPage'
import { AuditIndexPage } from './settings/audit/AuditIndexPage'
import { AuditTypePage } from './settings/audit/AuditTypePage'
import { ServiceProvidersPage } from './settings/service_providers/ServiceProvidersPage'
import { RustdeskOrgSettingsPage, RustdeskServersSettingsPage } from './settings/rustdesk/RustdeskPages'
import { CatalogSettingsPage } from './settings/catalog/CatalogSettingsPage'
import { AutonomyPage } from './settings/autonomy/AutonomyPage'
import { DeskConsolePage } from './desk/DeskConsolePage'
import { DeskBoardPage } from './desk/DeskBoardPage'
import { RustdeskLaunchPage } from './remote_connect/RustdeskLaunchPage'
import { RemoteSessionsPage } from './remote_connect/RemoteSessions'
import { InventoreeSettingsPage } from './settings/inventoree/InventoreeSettingsPage'
import { OpteemumSettingsPage } from './settings/opteemum/OpteemumSettingsPage'
import { ProactiviteeSettingsPage } from './settings/proactivitee/ProactiviteeSettingsPage'
import { SoftseeSettingsPage } from './settings/softsee/SoftseeSettingsPage'
import { SecuriteeSettingsPage } from './settings/securitee/SecuriteeSettingsPage'
import { PrinteengSettingsPage } from './settings/printeeng/PrinteengSettingsPage'
import { ProtecteeSettingsPage } from './settings/protectee/ProtecteeSettingsPage'
import { SaveenergeeSettingsPage } from './settings/saveenergee/SaveenergeeSettingsPage'
import { ProductiviteeSettingsPage } from './settings/productivitee/ProductiviteeSettingsPage'
import { CredentialsPanel, DiscoverySetupPanel, ScanRulesPanel, TelemetryPanel } from './settings/softsee/SoftseeDiscoveryPanels'
import { LiveAlarmsEditor } from './settings/proactivitee/LiveAlarmsEditor'
import { ApplicationsPage as SoftseeApplicationsPage } from './softsee/ApplicationsPage'
import { CertificatesPage } from './softsee/CertificatesPage'
import { DeviceListPage as SoftseeDeviceListPage } from './softsee/DeviceListPage'
import { DevicePage as SoftseeDevicePage } from './softsee/DevicePage'
import { InstallMonitorPage } from './softsee/InstallMonitorPage'
import { LicensesPage } from './softsee/LicensesPage'
import { SecuriteeDevicesPage } from './securitee/DevicesPage'
import { SecuriteeDevicePage } from './securitee/DevicePage'
import { SecuriteeEventsPage } from './securitee/EventsPage'
import { SecuriteeDetectionsPage } from './securitee/DetectionsPage'
import { SecuriteeEdrEventsPage } from './securitee/EdrEventsPage'
import { SecuriteeIncidentsPage } from './securitee/IncidentsPage'
import { GravityZonePage as SecuriteeGravityZonePage } from './securitee/gravityzone/GravityZonePage'
import { AdAccountsPage as SecuriteeAdAccountsPage } from './securitee/ad-accounts/AdAccountsPage'
import { LocalAccountsPage as SecuriteeLocalAccountsPage } from './securitee/local-accounts/LocalAccountsPage'
import { EmailDomainsPage as SecuriteeEmailDomainsPage } from './securitee/email-domains/EmailDomainsPage'
import { NetworkChecksPage as SecuriteeNetworkChecksPage } from './securitee/network-checks/NetworkChecksPage'
import { aroundParam, dayParam, deviceParam } from './securitee/deviceSearch'
import { ProtecteeDevicesPage } from './protectee/DevicesPage'
import { PrinteengDevicesPage, PrinteengEventsPage, PrinteengPrintersPage } from './printeeng/Pages'
import { SaveenergeeDashboardPage, SaveenergeeDevicesPage, SaveenergeeEventsPage } from './saveenergee/Pages'
import { ProductiviteeDevicesPage, ProductiviteeUsersPage, ProductiviteeUsersPeriodPage } from './productivitee/Pages'
import { ProductiviteeManagementPage } from './productivitee/ManagementPage'
import { ProductiviteeDashboardPage } from './productivitee/DashboardPage'
import { DayReportPage } from './productivitee/DayReportPage'
import { DeviceListPage as ProactiviteeDeviceListPage } from './proactivitee/DeviceListPage'
import { DevicePage as ProactiviteeDevicePage } from './proactivitee/DevicePage'
import { SnmpDashboardPage } from './proactivitee/SnmpDashboardPage'
import { SnmpServicesPage } from './proactivitee/SnmpServicesPage'
import { SnmpHostsPage } from './proactivitee/SnmpHostsPage'
import { CoreApplicationsPage } from './proactivitee/CoreApplicationsPage'
import { CoreApplicationsDashboardPage } from './proactivitee/CoreApplicationsDashboardPage'
import { ApplicationsDashboardPage } from './proactivitee/ApplicationsDashboardPage'
import { TicketListPage } from './easeedesk/TicketListPage'
import { TicketPage } from './easeedesk/TicketPage'
import { TicketsDashboardPage } from './easeedesk/TicketsDashboardPage'
import { EaseedeskDashboardPage } from './easeedesk/EaseedeskDashboardPage'
import { MyPerformancePage } from './easeedesk/MyPerformancePage'
import { MyPerformanceDashboardPage } from './easeedesk/dashboards/MyPerformanceDashboardPage'
import { NewPerformancePage } from './easeedesk/dashboards/NewPerformancePage'
import { ItSolutionsPage } from './easeedesk/ItSolutionsPage'
import { SolutionsCategoriesPage } from './easeedesk/SolutionsCategoriesPage'
import { ItPoliciesPage } from './easeedesk/ItPoliciesPage'
import { AllReportsPage } from './easeedesk/AllReportsPage'
import { OncallPage } from './easeedesk/OncallPage'
import { CustomersPage } from './easeedesk/CustomersPage'
import { CustomerTicketPage } from './easeedesk/CustomerTicketPage'
import { PolicyAckPage } from './easeedesk/PolicyAckPage'
import { DeskAnswerPage, DeskApprovePage, DeskConfirmPage, DeskConsentPage, DeskTicketPage } from './desk/DeskLinkPages'
import { RejectPlanningPage, ReopenResolvedPage, TicketApprovalPage, TicketFeedbackPage } from './easeedesk/TicketLinkPages'
import { AcceptEscalationPage, RejectEscalationPage } from './easeedesk/TicketEscalationLinkPages'
import { GpsTrackingPage } from './easeedesk/GpsTrackingPage'
import { GroupUsersPage } from './easeedesk/dashboards/GroupUsersPage'
import { LeaderBoardPage } from './easeedesk/dashboards/LeaderBoardPage'
import { QuickSupportPage } from './easeedesk/dashboards/QuickSupportPage'
import { OdpWorkorderPage } from './easeedesk/dashboards/OdpWorkorderPage'
import { RegionSkuPage } from './easeedesk/dashboards/RegionSkuPage'
import { SkuDashboardPage } from './easeedesk/dashboards/SkuDashboardPage'
import { UsersTicketsPage } from './easeedesk/dashboards/UsersTicketsPage'
import { RemarketingPage } from './easeedesk/dashboards/RemarketingPage'
import { SelfServicePage } from './easeedesk/SelfServicePage'
import { SelfServiceSearchesPage } from './easeedesk/SelfServiceSearchesPage'
import { ServiceRequestsPage } from './easeedesk/ServiceRequestsPage'
import { ServiceShopPage } from './easeedesk/ServiceShopPage'
import { ServiceCatalogPage } from './inventoree/ServiceCatalogPage'
import { ServiceCatalogCompositionPage } from './inventoree/ServiceCatalogCompositionPage'
import { ServiceCatalogDependenciesPage } from './inventoree/ServiceCatalogDependenciesPage'
import { ServiceCatalogCostsDashboardPage } from './inventoree/ServiceCatalogCostsDashboardPage'
import { ServiceCatalogCostsEntryPage, ServiceCatalogFormPage } from './inventoree/ServiceCatalogEntryPage'
import { EaseedeskReportsPage } from './settings/EaseedeskReportsPage'
import { CompanyReportsPage, ScheduledReportsPage } from './settings/company_reports/CompanyReportsPage'
import { InventoreeReportPage, PrinteengReportPage, ProactiviteeReportPage, ProductiviteeReportPage, SecuriteeReportPage } from './settings/company_reports/ModuleReportPage'
import { AuditRegisterPage } from './settings/audit/AuditRegisterPage'
import { AuditPaperPage } from './settings/audit/AuditPaperPage'
import { AuditAskPage } from './settings/audit/AuditAskPage'
import { AuditPromptsPage } from './settings/audit/AuditPromptsPage'
import { AuditSnapshotPage } from './settings/audit/AuditSnapshotPage'
import { UsersReportsPage } from './settings/company_reports/UsersReportsPage'
import { EaseetaskSettingsPage } from './settings/easeetask/EaseetaskSettingsPage'
import { CustomerReportPage } from './settings/company_reports/CustomerReportPage'
import { SettingsDirectoryPage } from './settings/SettingsDirectoryPage'
import { CostReportPage } from './settings/company_reports/CostReportPage'
import { BiReportsPage } from './settings/company_reports/BiReportsPage'
import { TicketCategoriesPage } from './settings/easeedesk/TicketCategoriesPage'
import { TicketPrioritiesPage } from './settings/easeedesk/TicketPrioritiesPage'
import { TicketSubcategoriesPage } from './settings/easeedesk/TicketSubcategoriesPage'
import { TicketCustomFieldsPage } from './settings/easeedesk/TicketCustomFieldsPage'
import { GroupDispatchingPage } from './settings/easeedesk/GroupDispatchingPage'
import { OfficeRoutingPage } from './settings/easeedesk/OfficeRoutingPage'
import { CabMeetingsPage } from './easeedesk/CabMeetingsPage'
import { AwaitingApprovalPage } from './easeedesk/AwaitingApprovalPage'
import { CabMeetingPage } from './easeedesk/CabMeetingPage'
import { TicketDispatchingPage } from './settings/easeedesk/TicketDispatchingPage'
import { ChatRecommendedActionsPage } from './settings/easeedesk/ChatRecommendedActionsPage'
import { AutoCommentsPage } from './settings/easeedesk/AutoCommentsPage'
import { AutoAssignPage } from './settings/easeedesk/AutoAssignPage'
import { DashboardTicketsPage } from './settings/easeedesk/DashboardTicketsPage'
import { CommentTypesPage } from './settings/easeedesk/CommentTypesPage'
import { EmailServersPage } from './settings/easeedesk/EmailServersPage'
import { PortalNotificationsPage } from './settings/easeedesk/PortalNotificationsPage'
import { AgentNotificationsPage } from './settings/easeedesk/AgentNotificationsPage'
import { MobileNotificationsPage, NotificationsPage } from './settings/easeedesk/NotificationsPage'
import { AdamIntopSettingsPage } from './settings/easeedesk/AdamIntopSettingsPage'
import { AdamIntopScenariosPage } from './settings/easeedesk/AdamIntopScenariosPage'
import { AdamIntopDialogflowPage } from './settings/easeedesk/AdamIntopDialogflowPage'
import { AdamIntopCronPage } from './settings/easeedesk/AdamIntopCronPage'
import { AdamIntopDefaultActionsPage } from './settings/easeedesk/AdamIntopDefaultActionsPage'
import { QuickDiagnosticActionsPage } from './settings/diagnostic/QuickDiagnosticActionsPage'
import { AiTopUsersPage } from './settings/diagnostic/AiTopUsersPage'
import { AiAnalizerActionsPage } from './settings/diagnostic/AiAnalizerActionsPage'
import { AdamIntopPythonFilesPage } from './settings/easeedesk/AdamIntopPythonFilesPage'
import { AdamIntopExtendedModulesPage } from './settings/easeedesk/AdamIntopExtendedModulesPage'
import { AdamIntopCleanActionsPage } from './settings/easeedesk/AdamIntopCleanActionsPage'
import { AdamIntopAssignCompanyPage } from './settings/easeedesk/AdamIntopAssignCompanyPage'
import { EmailTemplatesPage } from './settings/easeedesk/EmailTemplatesPage'
import { MobileTemplatesPage } from './settings/easeedesk/MobileTemplatesPage'
import { ThirdPartyTemplatesPage } from './settings/easeedesk/ThirdPartyTemplatesPage'
import { TicketGeneralSettingsPage } from './settings/easeedesk/TicketGeneralSettingsPage'
import { TicketFormBuilderPage } from './settings/easeedesk/TicketFormBuilderPage'
import { ReopenTicketPage } from './settings/easeedesk/ReopenTicketPage'
import { OncallSettingsPage } from './settings/easeedesk/OncallSettingsPage'
import { AutomatedUserPage } from './settings/easeedesk/AutomatedUserPage'
import { PlanningSettingsPage } from './settings/easeedesk/PlanningSettingsPage'
import { AssigningWorkflowsPage } from './settings/easeedesk/AssigningWorkflowsPage'
import { TicketFormConfigurationPage } from './settings/easeedesk/TicketFormConfigurationPage'
import { ExternalProvidersPage } from './settings/easeedesk/ExternalProvidersPage'
import { AutoChangeStatusPage } from './settings/easeedesk/AutoChangeStatusPage'
import { TriggerChangeStatusPage } from './settings/easeedesk/TriggerChangeStatusPage'
import { TicketStatusPage } from './settings/easeedesk/TicketStatusPage'
import { SlaSettingsPage } from './settings/easeedesk/SlaSettingsPage'
import { SlaHoursPage } from './settings/easeedesk/SlaHoursPage'
import { StatusTriggerActionsPage } from './settings/easeedesk/StatusTriggerActionsPage'
import { AssignAutoEscalationPage } from './settings/easeedesk/AssignAutoEscalationPage'
import { GroupEscalationSettingsPage } from './settings/easeedesk/GroupEscalationSettingsPage'
import { EscalationSettingsPage } from './settings/easeedesk/EscalationSettingsPage'
import { AutoEscalationSettingsPage } from './settings/easeedesk/AutoEscalationSettingsPage'
import { UpdateFormBuilderPage } from './settings/easeedesk/UpdateFormBuilderPage'
import { UpdateFormConfigurationPage } from './settings/easeedesk/UpdateFormConfigurationPage'
import { QuickFiltersPage } from './settings/easeedesk/QuickFiltersPage'
import { QuickFiltersGroupsPage } from './settings/easeedesk/QuickFiltersGroupsPage'
import { FeedbackComplimentsPage } from './settings/easeedesk/FeedbackComplimentsPage'
import { FeedbackSettingsPage } from './settings/easeedesk/FeedbackSettingsPage'
import { SettingsChangeHistoryPage } from './settings/easeedesk/SettingsChangeHistoryPage'
import { TicketTypeBuildPage } from './settings/easeedesk/TicketTypeBuildPage'
import { TicketTypeSheetPage } from './settings/easeedesk/TicketTypeSheetPage'
import { TicketTypesPage } from './settings/easeedesk/TicketTypesPage'
import { ChangeManagementPage } from './settings/easeedesk/ChangeManagementPage'
import { TicketTypeServicesPage } from './settings/easeedesk/TicketTypeServicesPage'
import { TicketTypeTimersPage } from './settings/easeedesk/TicketTypeTimersPage'
import { TicketTypePrioritiesPage } from './settings/easeedesk/TicketTypePrioritiesPage'
import { ChatSettingsPage } from './settings/easeedesk/ChatSettingsPage'
import { ChatMessagesPage } from './settings/easeedesk/ChatMessagesPage'
import { FastDispatchPage } from './settings/easeedesk/FastDispatchPage'
import { SampleCommentsPage } from './settings/easeedesk/SampleCommentsPage'
import { PredefinedMessagesPage } from './settings/easeedesk/PredefinedMessagesPage'
import { CollaborateTemplatesPage } from './settings/easeedesk/CollaborateTemplatesPage'
import { WorkflowSettingsPage } from './settings/easeedesk/WorkflowSettingsPage'
import { SkusPage } from './settings/easeedesk/SkusPage'
import { SkuCommandsPage } from './settings/easeedesk/SkuCommandsPage'
import { BugReportsPage, FeatureRequestsPage } from './feedback/ProductFeedbackPage'
import { isTicketList } from './api/easeedesk'
import { Shell } from './ui/Shell'

/**
 * Zona de rapoarte dinamice - numai in v4, fara pereche in portal. Poarta e pe
 * server (`ReportsAccess`: manageri si Full Access); cine n-are drept vede
 * "No access rights". In meniu: rotita -> General -> "Report builder", vizibil
 * numai pentru aceiasi oameni (`SettingsDrawer`, poarta `reports_builder`).
 */
export const reportsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/reports',
  /*
   * Un raport salvat are adresa lui: `/reports/saved/<id>` il arata (citire),
   * `/reports/saved/<id>/edit` il deschide in lucru pe ACELASI id.
   * Reimprospatarea si "Inapoi" pastreaza starea; `/reports` ramane "Raport
   * nou". Cele doua sunt copii ale lui `/reports`, fara ecran propriu: pagina
   * ramane aceeasi instanta cand se trece dintr-una in alta, deci compania
   * aleasa, limba si dialogul deschis nu se pierd.
   */
  component: function Reports() {
    const navigate = reportsRoute.useNavigate()
    const matchRoute = useMatchRoute()
    const edit = matchRoute({ to: '/reports/saved/$id/edit' })
    const view = matchRoute({ to: '/reports/saved/$id' })
    const id = edit ? edit.id : view ? view.id : undefined
    return <DynamicReportsPage reportId={id} editing={edit !== false} navigate={(to) => void navigate(reportsTarget(to))} />
  },
})

function reportsTarget(to: ReportsLocation) {
  if (to.id === null) return { to: '/reports' as const, replace: to.replace }
  return to.edit
    ? { to: '/reports/saved/$id/edit' as const, params: { id: to.id }, replace: to.replace }
    : { to: '/reports/saved/$id' as const, params: { id: to.id }, replace: to.replace }
}

export const reportsSavedRoute = createRoute({
  getParentRoute: () => reportsRoute,
  path: 'saved/$id',
  component: () => null,
})

export const reportsSavedEditRoute = createRoute({
  getParentRoute: () => reportsRoute,
  path: 'saved/$id/edit',
  component: () => null,
})

/**
 * Rutele v4. Aplicatia sta sub /app (basepath).
 * Rute statice Inventoree inainte de `$list`. Classic AmCharts boards
 * are dropped — no /classic routes.
 */

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, error) => !(error instanceof Error && 'status' in error) && count < 2,
      refetchOnWindowFocus: false,
    },
  },
})

const rootRoute = createRootRoute({ component: Shell })

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/inventoree/$list', params: { list: 'workstations' } })
  },
})

/*
 * ADM - descoperirea. Adresele sunt cele din portal, neschimbate: la ecranul
 * Changes se ajunge din CINCI module, si fiecare usa are calea ei
 * (`/adm/changes` din Overview, `/adm/changes/hardware` din Inventoree,
 * `/adm/changes/software` din Softsee, si asa mai departe). O legatura care
 * mergea ieri merge azi.
 *
 * Ruta fara ingustare sta INAINTEA celei cu `$scope`, ca sa nu fie inghitita
 * de ea.
 */
export const admDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/adm/dashboard',
  component: DiscoveryDashboardPage,
})

/*
 * `/adm/map` - USA DIN MENIUL SOFTSEE („ADM Map"), deci are rand in `MOVED`,
 * spre deosebire de impact si de exposure.
 *
 * `?root=<id>` e a doua usa, si nu trece prin meniu: din Easeedesk, de pe
 * elementele afectate ale unui tichet; din registru, de pe fisa unui element si
 * de pe fila lui de impact; si din catalogul de servicii, de pe compozitia si
 * dependentele unui serviciu. Toate scriu `adm/map?root=<id>`, deci adresa
 * ramane exact aia - un semn de carte vechi si o legatura dintr-un tichet
 * ajung tot aici.
 */
export const admMapRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/adm/map',
  validateSearch: (search: Record<string, unknown>): { root?: number; view?: number } => ({
    root: search.root === undefined ? undefined : Number(search.root),
    /* `?view=<id>`: un view salvat al hartii (Copy link). */
    view: search.view === undefined ? undefined : Number(search.view),
  }),
  component: AdmMap,
})

function AdmMap() {
  const { root, view } = admMapRoute.useSearch()
  return <MapPage root={root && root > 0 ? root : 0} view={view && view > 0 ? view : 0} />
}

/*
 * `/assistant/activity` (Direct Commands) si `/assistant/schedules` (Scheduled
 * questions) - ecranele lui Adam. Nu au rand in MOVED: nu duce nicio bara de
 * modul la ele, se ajunge din sertarul agentului (Direct Commands, ceasul).
 */
export const assistantActivityRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/assistant/activity',
  validateSearch: (search: Record<string, unknown>): { days?: number; kind?: string; device_id?: number } => ({
    days: search.days === undefined ? undefined : Number(search.days),
    kind: search.kind === undefined ? undefined : String(search.kind),
    device_id: search.device_id === undefined ? undefined : Number(search.device_id),
  }),
  component: AssistantActivity,
})

function AssistantActivity() {
  const { days, kind, device_id } = assistantActivityRoute.useSearch()
  return <ActivityPage days={days && days > 0 ? days : 7} kind={kind ?? ''} deviceId={device_id ?? 0} />
}

export const assistantSchedulesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/assistant/schedules',
  validateSearch: (search: Record<string, unknown>): { q?: string; device_id?: number } => ({
    q: search.q === undefined ? undefined : String(search.q),
    device_id: search.device_id === undefined ? undefined : Number(search.device_id),
  }),
  component: AssistantSchedules,
})

function AssistantSchedules() {
  const { q, device_id } = assistantSchedulesRoute.useSearch()
  return <AiSchedulesPage q={q ?? ''} deviceId={device_id ?? 0} />
}

/*
 * `/adm/wallboards` - ecranele de perete, emise si retrase.
 *
 * In portal era un fragment incarcat intr-un modal de pe tabloul de
 * descoperire (`$('#admWallboardContent').load(ADM_URL + '/wallboards')`).
 * Aici e o pagina la adresa ei: poarta un formular cu paisprezece controale si
 * un tabel, ceea ce nu e continut de fereastra, si asa poate fi data mai
 * departe ca legatura. Nu are rand in `MOVED`: nicio bara de modul nu duce la
 * ea, ca si la impact si la exposure.
 */
export const admWallboardsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/adm/wallboards',
  component: WallboardsPage,
})

/*
 * `/adm/impact/<id>` - la el se ajunge din TREI module, si nu prin meniu, ci de
 * pe fisa unui lucru: Easeedesk (elementele afectate ale unui tichet),
 * Inventoree (fisa unui element de CMDB, fila lui de impact) si catalogul de
 * servicii. De-aia nu are rand in `MOVED`: nicio bara de modul nu duce la el.
 */
export const admImpactRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/adm/impact/$ciId',
  component: AdmImpact,
})

function AdmImpact() {
  const { ciId } = admImpactRoute.useParams()
  return <ImpactPage ciId={Number(ciId)} />
}

/*
 * `/adm/exposure` - a cincea vedere din banda `_views`. Nu are rand in `MOVED`:
 * nicio bara de modul nu duce la ea, se ajunge din banda ecranelor de descoperire.
 */
export const admExposureRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/adm/exposure',
  component: ExposurePage,
})

export const admPendingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/adm/pending',
  component: PendingQueuePage,
})

/*
 * ERORILE si ACOPERIREA. Adresele sunt tot cele din portal: `/adm/errors`,
 * `/adm/error_detail/<cod>` era in CI3 o metoda cu parametru, si aici e
 * `/adm/errors/$code` - o singura schimbare, si e chiar cea care face legatura
 * citibila.
 *
 * FEREASTRA SI CATEGORIA STAU IN ADRESA, nu in memoria ecranului: asa legatura
 * se poate da mai departe, si intoarcerea din fisa unui cod nimereste inapoi
 * aceeasi felie a palniei.
 *
 * Ruta fara cod sta INAINTEA celei cu `$code`, ca sa nu fie inghitita de ea.
 */
export const admErrorsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/adm/errors',
  validateSearch: (search: Record<string, unknown>): { days?: number; category?: number } => ({
    days: search.days === undefined ? undefined : Number(search.days),
    category: search.category === undefined ? undefined : Number(search.category),
  }),
  component: AdmErrors,
})

function AdmErrors() {
  const { days, category } = admErrorsRoute.useSearch()
  return <ErrorsPage days={days && days > 0 ? days : 30} category={category && category > 0 ? category : 0} />
}

export const admErrorDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/adm/errors/$code',
  validateSearch: (search: Record<string, unknown>): { days?: number } => ({
    days: search.days === undefined ? undefined : Number(search.days),
  }),
  component: AdmErrorDetail,
})

function AdmErrorDetail() {
  const { code } = admErrorDetailRoute.useParams()
  const { days } = admErrorDetailRoute.useSearch()
  return <ErrorDetailPage code={code} days={days && days > 0 ? days : 30} />
}

export const admCoverageRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/adm/coverage',
  validateSearch: (search: Record<string, unknown>): { days?: number } => ({
    days: search.days === undefined ? undefined : Number(search.days),
  }),
  component: AdmCoverage,
})

function AdmCoverage() {
  const { days } = admCoverageRoute.useSearch()
  return <CoveragePage days={days && days > 0 ? days : 30} />
}

/*
 * Scanarile si programarile. Adresele sunt cele din portal, neschimbate -
 * `/adm/runs`, `/adm/run/<numar>`, `/adm/schedules` - fiindca fisa unei scanari
 * e o legatura pe care oamenii si-o trimit intre ei, si una care mergea ieri
 * trebuie sa mearga azi.
 *
 * `/adm/runs` sta INAINTEA lui `/adm/run/$id`: caile n-au acelasi numar de
 * bucati, deci nu se inghit una pe alta, dar ordinea le tine citite impreuna.
 */
export const admRunsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/adm/runs',
  component: RunsPage,
})

export const admRunRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/adm/run/$id',
  component: AdmRunDetail,
})

function AdmRunDetail() {
  const { id } = admRunRoute.useParams()
  /* Un numar care nu e numar ajunge la server ca zero, si acolo e 404 - ecranul
     nu se apara singur, ca sa nu existe doua raspunsuri la aceeasi intrebare. */
  return <RunDetailPage id={Number(id) || 0} />
}

export const admSchedulesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/adm/schedules',
  component: SchedulesPage,
})

export const admChangesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/adm/changes',
  component: () => <ChangesPage scope="" />,
})

/*
 * Coada de PROGRAME si podul de categorii. Adresele sunt cele din portal -
 * `Adm::softwarePending()` si `Adm::softwareCategories()` - deci o legatura
 * veche merge mai departe, si tot pe prima arata si intrarea de meniu din
 * `Shell::softseeNav()` (`adm/softwarePending`).
 *
 * `softwareCategories` nu e in bara: la el se ajunge din coada de programe, cu
 * legatura „Map your own categories".
 *
 * Coada de APARATE (`admPendingRoute`) sta mai sus, cu celelalte ecrane de
 * descoperire.
 */
export const admSoftwarePendingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/adm/softwarePending',
  component: SoftwarePendingPage,
})

export const admSoftwareCategoriesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/adm/softwareCategories',
  component: SoftwareCategoriesPage,
})

export const admChangesScopeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/adm/changes/$scope',
  beforeLoad: ({ params }) => {
    /* O ingustare pe care n-o cunoastem duce la ecranul general, ca in portal
       (`isset(self::changeScopes()[$scope]) ? $scope : ''`) - nu la un 404. */
    if (!isChangeScope(params.scope)) {
      throw redirect({ to: '/adm/changes' })
    }
  },
  component: AdmChangesScope,
})

function AdmChangesScope() {
  const { scope } = admChangesScopeRoute.useParams()
  return <ChangesPage scope={scope} />
}

/* `inventoree/dashboard`: in CI3 ruta duce la `Dashboard::module('inventoree')`,
   nu la o metoda din `Inventoree.php`. Tabloul AmCharts vechi ramane lasat -
   asta e tabloul de MODUL, cel pe care il vede omul azi. Sta INAINTEA lui
   `/inventoree/$list`, ca sa nu fie inghitita de el ca nume de lista. */
export const inventoreeDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/inventoree/dashboard',
  component: InventoreeDashboardPage,
})

export const inventoreePrintersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/inventoree/printers',
  component: PrintersPage,
})

export const inventoreeReportsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/inventoree/reports',
  component: ReportsPage,
})

export const inventoreeLicensesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/inventoree/software_licenses',
  component: SoftwareLicensesPage,
})

export const inventoreeUnassignedRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/inventoree/unassigned',
  component: UnassignedPage,
})

export const inventoreeUpgradesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/inventoree/alarms',
  component: UpgradesPage,
})

export const inventoreeDiscoveredRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/inventoree/live_devices',
  component: DiscoveredPage,
})

export const inventoreeManagedRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/inventoree/live_agentbased',
  component: ManagedPage,
})

export const inventoreeMapRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/inventoree/inventory_map',
  component: InventoryMapPage,
})

export const inventoreeDeviceRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/inventoree/device/$id',
  component: function InventoreeDevicePage() {
    const { id } = inventoreeDeviceRoute.useParams()
    return <DevicePage id={id} />
  },
})

/*
 * Connection Quality pe o pagina a lui, mare - "Open in new tab" de pe fila
 * fisei (ca fisa CMDB, deschisa in tab nou). Perioada si zoom-ul stau in
 * adresa (`?range=4h&from=...&to=...`), ca pagina sa se poata trimite; o
 * alegere noua inlocuieste adresa, nu adauga pasi in istoric la fiecare zoom.
 */
export const inventoreeDeviceCqRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/inventoree/device/$id/connection-quality',
  validateSearch: (search: Record<string, unknown>): CqFullSearch => ({
    range: search.range === undefined ? undefined : String(search.range),
    from: search.from === undefined ? undefined : String(search.from),
    to: search.to === undefined ? undefined : String(search.to),
    view: search.view === undefined ? undefined : String(search.view),
  }),
  component: function InventoreeDeviceCq() {
    const { id } = inventoreeDeviceCqRoute.useParams()
    const search = inventoreeDeviceCqRoute.useSearch()
    const navigate = inventoreeDeviceCqRoute.useNavigate()
    return (
      <ConnectionQualityFullPage
        id={Number(id)}
        search={search}
        onSearch={(next) => void navigate({ search: next, replace: true })}
      />
    )
  },
})

export const inventoreeDeviceEmptyRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/inventoree/device/',
  component: function InventoreeDeviceEmptyPage() {
    return <DevicePage id={undefined} />
  },
})

export const inventoreeEndpointRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/inventoree/endpoint_performance_dashboard',
  component: EndpointPerformancePage,
})

export const inventoreeListRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/inventoree/$list',
  beforeLoad: ({ params }) => {
    if (!isList(params.list)) {
      throw redirect({ to: '/inventoree/$list', params: { list: 'workstations' } })
    }
  },
  component: function InventoreeListPage() {
    const { list } = inventoreeListRoute.useParams()
    return <DeviceListPage list={isList(list) ? list : 'workstations'} />
  },
})

export const inventoreeSettingsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/inventoree',
  component: function InventoreeSettingsIndex() {
    return <InventoreeSettingsPage tab="" />
  },
})

/*
 * Settings › Opteemum › „Endpoint Performance Status", la adresa lui de pana
 * acum.
 *
 * Randul din meniu s-a mutat in Settings › Opteemum, dar ADRESA a ramas a
 * Inventoree: dupa ea sunt semnele de carte, `application/config/routes.php`,
 * `application/Services/V4/SettingsCut.php` si redirectul din portalul vechi.
 * Deci adresa deschide pagina hub-ului care ii tine acum randul, cu meniul
 * Opteemum in jurul ecranului - aceeasi forma ca la
 * `/settings/diagnostic_reports/$page`, care deschide tot `OpteemumSettingsPage`.
 *
 * Ruta STATICA e scrisa inaintea celei cu `$tab`, ca sa nu fie inghitita de ea
 * si sa ajunga iar in hub-ul Inventoree, de unde randul a plecat.
 */
export const inventoreeEndpointSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/inventoree/endpoint_status_settings',
  component: function InventoreeEndpointSettings() {
    return <OpteemumSettingsPage tab="endpoint_status_settings" />
  },
})

export const inventoreeSettingsTabRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/inventoree/$tab',
  beforeLoad: ({ params }) => {
    if (params.tab !== '' && !isInventoreeTab(params.tab)) {
      throw redirect({ to: '/settings/inventoree' })
    }
  },
  component: function InventoreeSettingsTab() {
    const { tab } = inventoreeSettingsTabRoute.useParams()
    return <InventoreeSettingsPage tab={tab} />
  },
})

/*
 * Settings -> CI rules. Adresa e chiar cea din portal (`settings/ci_rules`),
 * fiindca dupa ea se aprinde randul din rail-ul zonei Policies
 * (`SettingsMenu`, `'match' => ['settings/ci_rules']`) si tot ea e scrisa in
 * fila „Relation rules" din setarile Inventoree.
 */
export const ciRulesSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/ci_rules',
  component: CiRulesPage,
})

/* `/settings` - directorul tuturor ecranelor de setari (`settings/All_settings::index`). */
export const settingsDirectoryRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings',
  component: SettingsDirectoryPage,
})

export const generalSettingsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/general',
  component: function GeneralSettingsIndex() {
    return <GeneralSettingsPage tab="" />
  },
})

export const generalSettingsTabRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/general/$tab',
  beforeLoad: ({ params }) => {
    if (params.tab !== '' && !isGeneralTab(params.tab)) {
      throw redirect({ to: '/settings/general' })
    }
  },
  component: function GeneralSettingsTab() {
    const { tab } = generalSettingsTabRoute.useParams()
    return <GeneralSettingsPage tab={tab} />
  },
})

export const companySettingsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/companies',
  component: function CompanySettingsIndex() {
    return <CompanySettingsPage tab="" />
  },
})

export const companySettingsTabRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/companies/$tab',
  beforeLoad: ({ params }) => {
    if (params.tab !== '' && !isCompanyTab(params.tab)) {
      throw redirect({ to: '/settings/companies' })
    }
  },
  component: function CompanySettingsTab() {
    const { tab } = companySettingsTabRoute.useParams()
    return <CompanySettingsPage tab={tab} />
  },
})

/*
 * Settings -> Contracts. Adresa e chiar cea din portal
 * (`settings/customersV2/contracts`), fiindca dupa ea se aprinde randul din
 * rail-ul zonei Global (`SettingsMenu`, `'match' => ['settings/customersV2']`).
 * Filele stau sub ea cu numele metodelor vechi: `contractServiceSettings`,
 * `serviceList`, `service_properties`, `allContracts`.
 */
export const contractsSettingsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/customersV2/contracts',
  component: function ContractsSettingsIndex() {
    return <ContractsSettingsPage tab="" />
  },
})

export const contractsSettingsTabRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/customersV2/contracts/$tab',
  beforeLoad: ({ params }) => {
    if (params.tab !== '' && !isContractTab(params.tab)) {
      throw redirect({ to: '/settings/customersV2/contracts' })
    }
  },
  component: function ContractsSettingsTab() {
    const { tab } = contractsSettingsTabRoute.useParams()
    return <ContractsSettingsPage tab={tab} />
  },
})

/* Settings -> Contract Templates: ecran propriu in bara zonei Global. */
export const contractTemplatesSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/contracts_templates',
  component: ContractTemplatesPage,
})

/**
 * Settings -> User Accounts. Calea e chiar cea a portalului, deci
 * `/app/settings/users_accounts` deschide ecranul, iar
 * `/app/settings/users_accounts/groups` fila lui.
 */
export const userAccountsSettingsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/users_accounts',
  component: function UserAccountsSettingsIndex() {
    return <UserAccountsPage tab="" />
  },
})

export const userAccountsSettingsTabRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/users_accounts/$tab',
  beforeLoad: ({ params }) => {
    if (params.tab !== '' && !isUsersTab(params.tab)) {
      throw redirect({ to: '/settings/users_accounts' })
    }
  },
  component: function UserAccountsSettingsTab() {
    const { tab } = userAccountsSettingsTabRoute.useParams()
    return <UserAccountsPage tab={tab} />
  },
})

/**
 * Settings -> My Account. Calea e cea a portalului, `settings/user_accounts` -
 * si e chiar adresa pe care o scrie rotita din antet la randul "My Account"
 * (vezi `SettingsDrawer::account`). Fara ruta asta, randul ala ducea in gol.
 */
export const myAccountSettingsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/user_accounts',
  component: function MyAccountSettingsIndex() {
    return <MyAccountPage tab="" />
  },
})

export const myAccountSettingsTabRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/user_accounts/$tab',
  beforeLoad: ({ params }) => {
    if (params.tab !== '' && !isMyAccountTab(params.tab)) {
      throw redirect({ to: '/settings/user_accounts' })
    }
  },
  component: function MyAccountSettingsTab() {
    const { tab } = myAccountSettingsTabRoute.useParams()
    return <MyAccountPage tab={tab} />
  },
})

export const licensesSettingsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/licenses',
  component: function LicensesSettingsIndex() {
    return <LicensesSettingsPage tab="" />
  },
})

export const licensesSettingsTabRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/licenses/$tab',
  beforeLoad: ({ params }) => {
    if (params.tab !== '' && !isLicensesTab(params.tab)) {
      throw redirect({ to: '/settings/licenses' })
    }
  },
  component: function LicensesSettingsTab() {
    const { tab } = licensesSettingsTabRoute.useParams()
    return <LicensesSettingsPage tab={tab} />
  },
})

/*
 * Settings -> Customers si Settings -> Customer Services.
 *
 * Adresele sunt CHIAR cele din portal (`SettingsMenu`): `settings/customers/index`
 * e usa din rail, iar `settings/customers/{companies,groups}` sunt cele doua file.
 * `index` nu e o fila - e adresa de pornire, si duce la prima.
 */
export const customersSettingsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/customers',
  component: function CustomersSettingsIndex() {
    return <CustomersSettingsPage tab="companies" />
  },
})

export const customersSettingsTabRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/customers/$tab',
  /* `?company=7&panel=offices`: deschide fisa firmei pe fila ceruta - legatura
     din randul "Offices with no name" al contorului To do (`TodoMenu`). */
  validateSearch: (search: Record<string, unknown>): { company?: number; panel?: string } => ({
    company: search.company === undefined ? undefined : Number(search.company),
    panel: typeof search.panel === 'string' ? search.panel : undefined,
  }),
  component: function CustomersSettingsTab() {
    const { tab } = customersSettingsTabRoute.useParams()
    const { company, panel } = customersSettingsTabRoute.useSearch()
    /* `index` e adresa din rail, nu o fila: se deschide prima. */
    return (
      <CustomersSettingsPage
        tab={isCustomersTab(tab) ? tab : 'companies'}
        openCompany={company && company > 0 ? company : 0}
        openPanel={panel ?? ''}
      />
    )
  },
})

export const customerServicesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/customer_services',
  component: function CustomerServicesIndex() {
    return <CustomerServicesPage tab="services" />
  },
})

export const customerServicePropertiesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/customer_services/$tab',
  component: function CustomerServicesTab() {
    const { tab } = customerServicePropertiesRoute.useParams()
    return <CustomerServicesPage tab={isServicesTab(tab) ? tab : 'services'} />
  },
})

export const changeLogSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/change_log',
  component: ChangeLogSettingsPage,
})

/*
 * `/app/change_log`, adresa scurta - CEA DIN SUBSOL.
 *
 * In portal jurnalul are doua usi, si nu din intamplare: doua controllere
 * scrise separat, `controllers/Change_log.php` si
 * `controllers/settings/Change_log.php`. Usa scurta e cea pe care o scrie
 * subsolul FIECAREI pagini, si ea nu e o pagina de setari: controllerul ei
 * pune `appModule = 'change log'`, iar `SettingsMenu` inregistreaza jurnalul
 * numai sub `settings/change_log`. Deci `zoneFor('change_log')` iese gol si
 * ecranul se deschide FARA rail-ul de setari. Usa lunga, cea din rotita, il
 * are - acolo omul chiar umbla prin setari si vrea drumul inapoi.
 *
 * AICI STATEA UN `redirect` SPRE USA LUNGA, si el era greseala.
 *
 * Scris asa, ecranul mergea - dar oricine venea din subsol ajungea pe adresa
 * rotitei si primea rail-ul de setari lipit in stanga, pe un ecran la care se
 * uita din mijlocul altei munci. Adresa scurta din subsol nu mai insemna
 * nimic: se stergea din bara inainte ca pagina sa se deseneze.
 *
 * Ruta randeaza deci acelasi ecran, si atat. Rail-ul nu se scoate de aici -
 * se scoate de la sine: `Shell` intreaba serverul ce zona are ADRESA, si
 * pentru asta nu are niciuna.
 */
export const changeLogShortRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/change_log',
  /* Usa scurta e a TUTUROR, ca in portal (`Change_log::index` nu cerea niciun
     drept): acelasi ecran, `settings = false` - fara desfacerea randurilor si
     fara uneltele rotitei. */
  component: function ChangeLogShort() {
    return <ChangeLogSettingsPage settings={false} />
  },
})

/*
 * FEEDBACKUL DESPRE PRODUS: celelalte doua legaturi din SUBSOL.
 *
 * `routes.php` (randurile 118-119) le tine pe amandoua pe acelasi controller,
 * cu felul luat din segment: `feature_requests -> product_feedback/index/feature`
 * si `bug_reports -> product_feedback/index/bug`. Aici la fel: aceeasi
 * componenta, cu felul dat ca proprietate.
 *
 * ADRESELE RAMAN EXACT ASA. `feature_requests` era acolo inaintea defectelor si
 * e deja in meniu si in subsol - o adresa care mergea ieri trebuie sa mearga si
 * maine - iar `bug_reports` e perechea ei. NU sub `/settings`: ecranul e al
 * tuturor, nu o setare, si nu are rail. Vezi comentariul din `routes.php` si
 * `ShellFooter.test.tsx`, care cere fix aceste doua adrese.
 */
export const featureRequestsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/feature_requests',
  component: FeatureRequestsPage,
})

export const bugReportsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/bug_reports',
  component: BugReportsPage,
})

export const contactsSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/contacts',
  component: ContactsSettingsPage,
})

/**
 * Settings -> Authentication. Calea e EXACT cea din `Navigation\SettingsMenu`
 * (`settings/authentication`), ca intrarea din rail sa duca aici.
 */
export const authenticationSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/authentication',
  component: function AuthenticationSettingsIndex() {
    const navigate = authenticationSettingsRoute.useNavigate()
    return (
      <AuthenticationSettingsPage
        section=""
        onSection={(section) =>
          void (section === 'providers'
            ? navigate({ to: '/settings/authentication' })
            : navigate({ to: '/settings/authentication/$section', params: { section } }))
        }
      />
    )
  },
})

/**
 * O sectiune a ecranului (21 octombrie 2026): `providers`, `sign_in_policy`,
 * `provisioning`, `directory_sync`, `sign_in_activity`. Un nume necunoscut se
 * intoarce pe adresa de baza, care deschide prima sectiune.
 */
export const authenticationSectionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/authentication/$section',
  beforeLoad: ({ params }) => {
    if (!isAuthSection(params.section)) {
      throw redirect({ to: '/settings/authentication' })
    }
  },
  component: function AuthenticationSettingsSection() {
    const { section } = authenticationSectionRoute.useParams()
    const navigate = authenticationSectionRoute.useNavigate()
    return (
      <AuthenticationSettingsPage
        section={section}
        onSection={(next) =>
          void (next === 'providers'
            ? navigate({ to: '/settings/authentication' })
            : navigate({ to: '/settings/authentication/$section', params: { section: next } }))
        }
      />
    )
  },
})

/** A doua pagina a aceluiasi ecran: regulile de grup ale unui furnizor. */
export const authenticationGroupsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/authentication/groups/$providerId',
  component: AuthGroupRulesPage,
})

/**
 * Settings -> Auth Vault (Pass Safe).
 *
 * Meniul scrie `settings/pass_safe/index` (in portal, `index()` era un redirect
 * catre `getDeviceType`), iar registrul zonei scrie forma scurta - deci
 * amandoua adresele duc la acelasi ecran. Vezi `SettingsMenu::normalizeUrl`.
 */
export const passSafeSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/pass_safe/index',
  component: PassSafePage,
})

export const passSafeSettingsShortRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/pass_safe',
  component: PassSafePage,
})

export const downloadAgentSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/download_agent',
  component: DownloadAgentPage,
})

/*
 * Settings -> General -> RustDesk / RustDesk servers (7 octombrie 2026): doua
 * intrari in meniul din stanga, sub AI Agent (`SettingsMenu`). Adresele de pe
 * 6 octombrie, cand erau file in bara paginii de firma, trimit aici. Ele stau
 * ca rute STATICE, care bat `/settings/companies/$tab`, deci nu mai trec prin
 * `isCompanyTab` - iar tintele lor sunt pagini, nu alte redirectari: bucla nu
 * are pe unde sa se inchida.
 *
 * `/settings/rustdesk` a fost pana pe 6 octombrie ecranul furnizorului; acum e
 * al organizatiei, si furnizorul e intrarea de dedesubt.
 */
export const rustdeskSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/rustdesk',
  component: RustdeskOrgSettingsPage,
})

export const rustdeskServersSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/rustdesk_servers',
  component: RustdeskServersSettingsPage,
})

export const companyRustdeskMovedRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/companies/rustdesk',
  beforeLoad: () => {
    throw redirect({ to: '/settings/rustdesk' })
  },
})

export const companyRustdeskServersMovedRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/companies/rustdesk_servers',
  beforeLoad: () => {
    throw redirect({ to: '/settings/rustdesk_servers' })
  },
})

/**
 * Settings -> Service Catalog (Policies). Adresa e cea din `SettingsMenu`
 * (`settings/catalog`), dupa care se aprinde randul din rail; ecranul e cel
 * din `settings/catalog/index.php` cu vizibilitatea deasupra programarilor.
 */
export const catalogSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/catalog',
  component: CatalogSettingsPage,
})

/* Policies > Agent Autonomy - `settings/autonomy`, adresa din `SettingsMenu`. */
export const autonomySettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/autonomy',
  component: AutonomyPage,
})

export const deskConsoleRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/autonomy/desk',
  component: DeskConsolePage,
})

export const deskBoardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/desk',
  component: DeskBoardPage,
})

/**
 * Agent Releases. Adresa e cea din `Services\Navigation\SettingsMenu`
 * (`settings/agent_releases`), de unde o citesc si rail-ul zonei Global, si
 * sertarul rotitei - deci o legatura din meniu deschide chiar ecranul asta.
 */
export const agentReleasesSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/agent_releases',
  component: AgentReleasesPage,
})

/**
 * IT Audit. Adresele sunt cele din portal (`settings/audit`,
 * `settings/audit/type/N`) - asa scrie in `Services\Navigation\SettingsMenu`,
 * de unde le citeste rotita. Celelalte foi ale auditului (snapshot, register,
 * prompts, ask, paper) isi pun rutele langa astea, pe masura ce se muta.
 */
export const auditIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/audit',
  component: AuditIndexPage,
})

export const auditTypeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/audit/type/$id',
  component: function AuditTypeRoute() {
    const { id } = auditTypeRoute.useParams()
    return <AuditTypePage id={Number(id)} />
  },
})

/**
 * Service Providers. NU e sub `settings/`, desi ecranul e in zona Global a
 * setarilor: in `SettingsMenu` scrie `services_providers/service_providers`,
 * adresa controllerului vechi, si aia ramane.
 */
export const serviceProvidersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/services_providers/service_providers',
  component: ServiceProvidersPage,
})

export const agentInstallSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/install_options',
  component: AgentInstallPage,
})

/**
 * Planurile de etaj (Connection Quality, faza 5). Modul nou, fara pereche in
 * portal; se ajunge din panoul Connection Quality de la Install Options.
 * OpenLayers se incarca abia in ecranul unui etaj (`FloorPlan.tsx`, lazy).
 */
/** Settings -> Connection Quality (intrare in meniul Settings, sub Agent Install). */
export const connectionQualitySettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/connection_quality',
  component: ConnectionQualitySettingsPage,
})

export const floorPlansSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/floor_plans',
  component: FloorPlansPage,
})

export const floorPlanSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/floor_plans/$id',
  component: function FloorPlanRoute() {
    const { id } = floorPlanSettingsRoute.useParams()
    return <FloorPlanPage id={Number(id)} />
  },
})

export const remoteConnectSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/remote_connect',
  component: RemoteConnectPage,
})

/**
 * Lansarea unei conexiuni RustDesk - `Remote_connect::rustdesk_launch`.
 *
 * Adresa e EXACT cea din portal (`remote_connect/rustdesk_launch/{device}/
 * {ticket}`), fiindca butonul Connect raspundea cu ea in `hostUrlJoin` si o
 * deschidea in fila noua; legaturile vechi duc in acelasi loc. Tichetul e
 * optional - lista de aparate din Opteemum deschide pagina fara el.
 */
export const rustdeskLaunchRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/remote_connect/rustdesk_launch/$deviceId/$ticketId',
  component: RustdeskLaunch,
})

export const rustdeskLaunchNoTicketRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/remote_connect/rustdesk_launch/$deviceId',
  component: RustdeskLaunchNoTicket,
})

function RustdeskLaunch() {
  const { deviceId, ticketId } = rustdeskLaunchRoute.useParams()
  /* Un numar care nu e numar ajunge la server ca zero, si acolo e 404. */
  return <RustdeskLaunchPage deviceId={Number(deviceId) || 0} ticketId={Number(ticketId) || 0} />
}

function RustdeskLaunchNoTicket() {
  const { deviceId } = rustdeskLaunchNoTicketRoute.useParams()
  return <RustdeskLaunchPage deviceId={Number(deviceId) || 0} ticketId={0} />
}

export const apiIntegrationSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/api_integration',
  component: ApiIntegrationPage,
})

/* Settings -> Webhooks (cerinta CEC R12): abonamentele de iesire si jurnalul livrarilor. */
export const webhooksSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/webhooks',
  component: WebhooksPage,
})

/* Jurnalul apelurilor API: fila a doua din API Integration. */
export const apiLogSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/api_integration/log',
  component: ApiLogPage,
})

/*
 * Settings -> AI Agent. Acelasi ecran, doua scopuri si doua adrese - exact ale
 * portalului: cea din zona Global e a platformei (laboratoare, chei, trepte),
 * cea din General e a firmei din sesiune. Rail-ul are cate o intrare in fiecare
 * zona, si `SettingsMenu::zoneFor()` le desparte dupa cel mai LUNG prefix,
 * fiindca a doua incepe cu prima. Cea a firmei sta INAINTE, ca sa nu fie
 * inghitita de cealalta.
 */
export const aiAgentCompanySettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/ai_agent/company',
  component: AiAgentCompanyPage,
})

export const aiAgentSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/ai_agent',
  component: AiAgentGlobalPage,
})

/** Fleet System Alarms: /proactivitee/alarms (and /opteemum/alarms, /securitee/alarms). */
export const alarmsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/$door/alarms',
  beforeLoad: ({ params }) => {
    if (!isDoor(params.door)) {
      throw redirect({ to: '/$door/alarms', params: { door: 'proactivitee' } })
    }
  },
  component: function AlarmsPage() {
    const { door } = alarmsRoute.useParams()
    return <AlarmFleetPage door={isDoor(door) ? door : 'proactivitee'} />
  },
})

function opteemumList(
  path: '/opteemum/workstations' | '/opteemum/servers' | '/opteemum/mobiles' | '/opteemum/inactive' | '/opteemum/live_devices',
  list: 'workstations' | 'servers' | 'mobiles' | 'inactive' | 'live_devices',
) {
  return createRoute({
    getParentRoute: () => rootRoute,
    path,
    component: function OpteemumNamedList() {
      return <OpteemumDeviceListPage list={isOpteemumList(list) ? list : 'workstations'} />
    },
  })
}

export const opteemumWorkstationsRoute = opteemumList('/opteemum/workstations', 'workstations')
export const opteemumServersRoute = opteemumList('/opteemum/servers', 'servers')
export const opteemumMobilesRoute = opteemumList('/opteemum/mobiles', 'mobiles')
export const opteemumInactiveRoute = opteemumList('/opteemum/inactive', 'inactive')
export const opteemumLiveRoute = opteemumList('/opteemum/live_devices', 'live_devices')

export const opteemumDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/opteemum/dashboard',
  component: function OpteemumModuleBoard() {
    return <ModuleBoardPage query={(s) => moduleBoardQuery('opteemum', s)} basePath="/app/opteemum/dashboard" />
  },
})

export const opteemumUnassignedRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/opteemum/unassigned',
  component: OpteemumUnassignedPage,
})

export const opteemumApplicationsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/opteemum/applications',
  component: OpteemumApplicationsPage,
})

export const opteemumScheduleRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/opteemum/schedule_management',
  component: SchedulePage,
})

export const opteemumRemoteRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/opteemum/remote_connect',
  component: RemotePage,
})

/** Jurnalul sesiunilor remote si inregistrarile lor (CEC 65) - numai in v4. */
export const opteemumRemoteSessionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/opteemum/remote_sessions',
  component: RemoteSessionsPage,
})

export const opteemumDeviceRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/opteemum/device/$id',
  component: function OpteemumStandaloneDevice() {
    const { id } = opteemumDeviceRoute.useParams()
    return <OpteemumDevicePage id={Number(id)} />
  },
})

export const opteemumSettingsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/opteemum',
  component: function OpteemumSettingsIndex() {
    return <OpteemumSettingsPage tab="" />
  },
})

export const opteemumSettingsTabRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/opteemum/$tab',
  beforeLoad: ({ params }) => {
    if (params.tab !== '' && !isOpteemumTab(params.tab) && !isDiagnosticReportPage(params.tab)) {
      throw redirect({ to: '/settings/opteemum' })
    }
  },
  component: function OpteemumSettingsTab() {
    const { tab } = opteemumSettingsTabRoute.useParams()
    return <OpteemumSettingsPage tab={tab} />
  },
})

export const diagnosticReportsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/diagnostic_reports',
  beforeLoad: () => {
    throw redirect({ to: '/settings/diagnostic_reports/$page', params: { page: 'computer_scan' } })
  },
})

export const diagnosticReportsPageRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/diagnostic_reports/$page',
  beforeLoad: ({ params }) => {
    if (!isDiagnosticReportPage(params.page)) {
      throw redirect({ to: '/settings/diagnostic_reports/$page', params: { page: 'computer_scan' } })
    }
  },
  component: function DiagnosticReportsPage() {
    const { page } = diagnosticReportsPageRoute.useParams()
    return <OpteemumSettingsPage tab={isDiagnosticReportPage(page) ? page : 'computer_scan'} />
  },
})

export const proactiviteeSettingsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/proactivitee',
  component: function ProactiviteeSettingsIndex() {
    return <ProactiviteeSettingsPage tab="" />
  },
})

export const proactiviteeSettingsTabRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/proactivitee/$tab',
  beforeLoad: ({ params }) => {
    if (params.tab !== '' && !isProactiviteeTab(params.tab)) {
      throw redirect({ to: '/settings/proactivitee' })
    }
  },
  component: function ProactiviteeSettingsTab() {
    const { tab } = proactiviteeSettingsTabRoute.useParams()
    return <ProactiviteeSettingsPage tab={tab} />
  },
})

/*
 * Policies > Alarms. `SettingsMenu` scrie adresa portalului,
 * `settings/alarms_new/proactivitee`, si e PRIMA intrare a zonei - deci si
 * tinta clicului pe „Policies" din bara setarilor.
 *
 * Pana pe 7 octombrie 2026 ruta trimitea mai departe, la
 * `/settings/proactivitee/alarms`: acelasi editor viu, dar pe o adresa a
 * MODULULUI. Acolo niciun `match` al zonei nu se potriveste, rail-ul zonei
 * tacea, pagina isi desena meniul Proactivitee si in bara se aprindea
 * Proactivitee - din Policies nu se mai vedeau Data Collection, Discovery,
 * Scan Rules, CI Rules.
 *
 * Acum editorul se deseneaza pe adresa zonei, sub rail-ul Policies (`match`
 * pe `settings/alarms_new`). Aceleasi randuri, aceeasi componenta: doua usi
 * spre acelasi editor, fiecare cu meniul ei. Settings > Proactivitee > Alarms
 * ramane fila modulului.
 */
export const settingsAlarmsNewProactiviteeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/alarms_new/proactivitee',
  component: function PoliciesAlarms() {
    return <LiveAlarmsEditor />
  },
})

export const softseeSettingsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/softsee',
  component: function SoftseeSettingsIndex() {
    return <SoftseeSettingsPage tab="" />
  },
})

export const softseeSettingsTabRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/softsee/$tab',
  /* `?assistant=1` pe fila discovery_setup: deschide "Set up discovery" -
     legatura din randul "Network discovery not set up" al contorului To do (`TodoMenu`). */
  validateSearch: (search: Record<string, unknown>): { assistant?: number } => ({
    assistant: search.assistant === undefined ? undefined : Number(search.assistant),
  }),
  beforeLoad: ({ params }) => {
    if (params.tab !== '' && !isSoftseeTab(params.tab)) {
      throw redirect({ to: '/settings/softsee' })
    }
  },
  component: function SoftseeSettingsTab() {
    const { tab } = softseeSettingsTabRoute.useParams()
    const { assistant } = softseeSettingsTabRoute.useSearch()
    return <SoftseeSettingsPage tab={tab} openAssistant={assistant === 1} />
  },
})

/*
 * Settings > Securitee si Settings > Printeeng (settings/Securitee::*,
 * settings/Printeeng::*), surorile Softsee: acelasi tipar, rail + fila.
 * 13 septembrie 2026.
 */
export const securiteeSettingsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/securitee',
  component: function SecuriteeSettingsIndex() {
    return <SecuriteeSettingsPage tab="" />
  },
})

export const securiteeSettingsTabRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/securitee/$tab',
  beforeLoad: ({ params }) => {
    if (params.tab !== '' && !isSecuriteeTab(params.tab)) {
      throw redirect({ to: '/settings/securitee' })
    }
  },
  component: function SecuriteeSettingsTab() {
    const { tab } = securiteeSettingsTabRoute.useParams()
    return <SecuriteeSettingsPage tab={tab} />
  },
})

export const printeengSettingsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/printeeng',
  component: function PrinteengSettingsIndex() {
    return <PrinteengSettingsPage tab="" />
  },
})

export const printeengSettingsTabRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/printeeng/$tab',
  beforeLoad: ({ params }) => {
    if (params.tab !== '' && !isPrinteengTab(params.tab)) {
      throw redirect({ to: '/settings/printeeng' })
    }
  },
  component: function PrinteengSettingsTab() {
    const { tab } = printeengSettingsTabRoute.useParams()
    return <PrinteengSettingsPage tab={tab} />
  },
})

/*
 * Settings > Protectee (settings/Protectee::*), sora Softsee, partea a doua:
 * profilele de backup ale firmei. Rail + fila, ca la Securitee si Printeeng.
 * 13 septembrie 2026.
 */
export const protecteeSettingsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/protectee',
  component: function ProtecteeSettingsIndex() {
    return <ProtecteeSettingsPage tab="" />
  },
})

export const protecteeSettingsTabRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/protectee/$tab',
  beforeLoad: ({ params }) => {
    if (params.tab !== '' && !isProtecteeSettingsTab(params.tab)) {
      throw redirect({ to: '/settings/protectee' })
    }
  },
  component: function ProtecteeSettingsTab() {
    const { tab } = protecteeSettingsTabRoute.useParams()
    return <ProtecteeSettingsPage tab={tab} />
  },
})

/* Settings > Saveenergee (settings/Saveenergee::*): profilele de ore de lucru si consumul. */
export const saveenergeeSettingsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/saveenergee',
  component: function SaveenergeeSettingsIndex() {
    return <SaveenergeeSettingsPage tab="" />
  },
})

export const saveenergeeSettingsTabRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/saveenergee/$tab',
  beforeLoad: ({ params }) => {
    if (params.tab !== '' && !isSaveenergeeSettingsTab(params.tab)) {
      throw redirect({ to: '/settings/saveenergee' })
    }
  },
  component: function SaveenergeeSettingsTab() {
    const { tab } = saveenergeeSettingsTabRoute.useParams()
    return <SaveenergeeSettingsPage tab={tab} />
  },
})

/* Settings > Productivitee (settings/Productivitee::*): etichetarea aplicatiilor pe grup si pe firma. */
export const productiviteeSettingsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/productivitee',
  component: function ProductiviteeSettingsIndex() {
    return <ProductiviteeSettingsPage tab="" />
  },
})

export const productiviteeSettingsTabRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/productivitee/$tab',
  beforeLoad: ({ params }) => {
    if (params.tab !== '' && !isProductiviteeSettingsTab(params.tab)) {
      throw redirect({ to: '/settings/productivitee' })
    }
  },
  component: function ProductiviteeSettingsTab() {
    const { tab } = productiviteeSettingsTabRoute.useParams()
    return <ProductiviteeSettingsPage tab={tab} />
  },
})

/*
 * Cele patru intrari de descoperire din rail-ul zonei Policies
 * (`SettingsMenu`: Data Collection, Discovery Setup, Discovery Credentials,
 * Scan Rules), la adresele lor din portal: `settings/telemetry`,
 * `settings/discovery_setup`, `settings/vault`, `settings/scan_rules`.
 *
 * Ecranele sunt DEJA mutate, ca file ale setarilor Softsee
 * (`SoftseeDiscoveryPanels`, `SettingsSoftseeDiscoveryController`) - dar
 * numai la adresa `settings/softsee/<fila>`. Rail-ul le scria cu adresele de
 * mai sus, `settingsUrl()` nu le gasea printre hub-uri si le trimitea in
 * portalul vechi, care nu mai e pe server: patru din noua intrari Policies
 * duceau in gol.
 *
 * Fiecare face ce facea controllerul vechi la deschidere directa:
 *  - `Telemetry::index` si `Discovery_setup::index` randau fragmentul ca
 *    pagina, sub rail-ul zonei (`fragmentTemplate` cu `pageTitle`) - aici se
 *    deseneaza panoul sub rail-ul Policies;
 *  - `Vault::index` si `Scan_rules::index` trimiteau la
 *    `settings/softsee#credentials` / `#scan_rules`. Pana pe 7 octombrie 2026
 *    si aici trimiteau la fila Softsee - si de acolo meniul din stanga era al
 *    lui Softsee, nu al zonei: din Policies > Scan Rules nu mai vedeai CI
 *    Rules. Acum se deseneaza si ele panoul pe loc, sub rail-ul Policies, ca
 *    primele doua. Fila Softsee ramane, cu acelasi panou, pentru cine vine
 *    din Softsee (`settingsZoneLanding.test.ts`).
 */
export const telemetrySettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/telemetry',
  component: function TelemetrySettings() {
    return (
      <div id="content">
        <TelemetryPanel />
      </div>
    )
  },
})

export const discoverySetupSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/discovery_setup',
  component: function DiscoverySetupSettings() {
    return (
      <div id="content">
        <DiscoverySetupPanel />
      </div>
    )
  },
})

export const vaultSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/vault',
  component: CredentialsPanel,
})

export const scanRulesSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/scan_rules',
  component: ScanRulesPanel,
})

export const softseePageRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/softsee/$page',
  beforeLoad: ({ params }) => {
    /*
     * `classic` si `dashboard` nu sunt pagini Softsee: tabloul AmCharts a fost
     * lasat, iar `/softsee/dashboard` e tabloul de MODUL, care deocamdata sta
     * in CI3 (`Dashboard::module('softsee')`). Nu sunt in `PAGES`, deci
     * `isSoftseePage` le trimite deja de aici; `device` are ruta lui, cu id.
     *
     * Atentie: hotararea "se lasa" e numai a tabloului AmCharts. Tabloul de
     * MODUL se muta - Easeedesk are ruta lui (`/easeedesk/dashboard`), iar
     * Inventoree si-a capatat-o pe 9 septembrie 2026
     * (`inventoreeDashboardRoute`). Cand vine si Softsee, aici se adauga o
     * ruta ca aceea si numele modulului intra in
     * `Application\Services\V4\ModuleBoards::MOVED` - nu in
     * `SoftseeCut::PAGES`, fiindca tabloul de modul nu e o pagina din
     * `Softsee.php`.
     */
    if (!isSoftseePage(params.page) || params.page === 'device') {
      throw redirect({ to: '/softsee/$page', params: { page: 'all_devices' } })
    }
    /* Procedures a trecut in Settings > Softsee (cec-master aa267b09e);
       adresa veche duce acolo, ca in portal (`redirect('settings/softsee#procedures')`). */
    if (params.page === 'procedures') {
      throw redirect({ to: '/settings/softsee/$tab', params: { tab: 'procedures' } })
    }
  },
  component: function SoftseePage() {
    const { page } = softseePageRoute.useParams()
    if (isSoftseeList(listOf(page)) && (page === 'all_devices' || page === 'workstations' || page === 'servers' || page === 'mobiles')) {
      return <SoftseeDeviceListPage list={listOf(page)} />
    }
    if (page === 'applications') return <SoftseeApplicationsPage />
    if (page === 'licenses') return <LicensesPage />
    if (page === 'certificates') return <CertificatesPage />
    if (page === 'installMonitor') return <InstallMonitorPage />
    return <SoftseeDeviceListPage list="all" />
  },
})

/*
 * `<modul>/dashboard` pentru Softsee, Opteemum si Proactivitee.
 *
 * Bara fiecaruia are "Dashboard" (vezi `Shell::softsee()` in API), si pana
 * acum adresa aia iesea din /app catre portalul vechi - care nu mai e pe
 * server. Tabloul de MODUL e acelasi ecran pentru toate (`ModuleBoardPage`),
 * deci aici nu se adauga decat adresa si capatul.
 *
 * NU e tabloul AmCharts vechi al modulului: acela a fost lasat de Bogdan pe 6
 * septembrie 2026 si nu primeste ruta.
 *
 * Fiecare sta INAINTEA lui `/<modul>/$page`, ca sa nu fie inghitita de el ca
 * nume de lista - la fel ca `/proactivitee/alarms`.
 */
export const softseeDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/softsee/dashboard',
  component: function SoftseeModuleBoard() {
    return <ModuleBoardPage query={(s) => moduleBoardQuery('softsee', s)} basePath="/app/softsee/dashboard" />
  },
})

/**
 * Securitee, in /app de pe 12 septembrie 2026: All Devices, Events si tabloul
 * de modul. `/securitee/alarms` era deja (`alarmsRoute`). `index` -> all_devices,
 * ca `Securitee::index`.
 */
export const securiteeIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/securitee',
  beforeLoad: () => {
    throw redirect({ to: '/securitee/all_devices' })
  },
})

export const securiteeDevicesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/securitee/all_devices',
  component: SecuriteeDevicesPage,
})

/*
 * Un aparat din All devices, pe pagina lui: aici duc legaturile spre aparat din
 * Incidents / Detections / EDR events. Fila sta in adresa (`?tab=`) si se
 * inlocuieste, nu se adauga in istoric la fiecare clic.
 */
export const securiteeDeviceRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/securitee/all_devices/$id',
  beforeLoad: ({ params }) => {
    if (!/^[1-9]\d*$/.test(params.id)) throw redirect({ to: '/securitee/all_devices' })
  },
  validateSearch: (search: Record<string, unknown>): { tab?: string } => ({
    tab: typeof search.tab === 'string' && /^[a-z_]+$/.test(search.tab) ? search.tab : undefined,
  }),
  component: function SecuriteeDevice() {
    const { id } = securiteeDeviceRoute.useParams()
    const { tab } = securiteeDeviceRoute.useSearch()
    const navigate = securiteeDeviceRoute.useNavigate()
    return <SecuriteeDevicePage key={id} id={Number(id)} tab={tab} onTab={(next) => void navigate({ search: { tab: next }, replace: true })} />
  },
})

export const securiteeEventsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/securitee/events',
  component: SecuriteeEventsPage,
})

/*
 * `?device=` (si `?day=` / `?around=` pe EDR events): legaturile spre un aparat din randurile
 * Securitee deschid lista numai pe el. `key` reia ecranul de la capat cand
 * adresa arata alt aparat; x de pe pastila scoate aparatul din adresa.
 */
export const securiteeDetectionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/securitee/detections',
  validateSearch: (search: Record<string, unknown>): { device?: number } => ({ device: deviceParam(search.device) }),
  component: function SecuriteeDetections() {
    const { device } = securiteeDetectionsRoute.useSearch()
    const navigate = securiteeDetectionsRoute.useNavigate()
    return <SecuriteeDetectionsPage key={device ?? 0} device={device} onClearDevice={() => void navigate({ search: {} })} />
  },
})

export const securiteeEdrEventsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/securitee/edr-events',
  validateSearch: (search: Record<string, unknown>): { device?: number; day?: string; around?: string } => ({
    device: deviceParam(search.device),
    day: dayParam(search.day),
    around: aroundParam(search.around),
  }),
  component: function SecuriteeEdrEvents() {
    const { device, day, around } = securiteeEdrEventsRoute.useSearch()
    const navigate = securiteeEdrEventsRoute.useNavigate()
    return (
      <SecuriteeEdrEventsPage
        key={`${device ?? 0}-${day ?? ''}-${around ?? ''}`}
        device={device}
        day={day}
        around={around}
        onClearDevice={() => void navigate({ search: (s) => ({ ...s, device: undefined }) })}
        // x pe fereastra: ziua intreaga a momentului
        onClearAround={() => void navigate({ search: (s) => ({ ...s, around: undefined, day: s.around?.slice(0, 10) }) })}
      />
    )
  },
})

export const securiteeIncidentsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/securitee/incidents',
  validateSearch: (search: Record<string, unknown>): { device?: number; incident?: number } => ({ device: deviceParam(search.device), incident: deviceParam(search.incident) }),
  component: function SecuriteeIncidents() {
    const { device, incident } = securiteeIncidentsRoute.useSearch()
    const navigate = securiteeIncidentsRoute.useNavigate()
    const clear = () => void navigate({ search: {} })
    return <SecuriteeIncidentsPage key={`${device ?? 0}-${incident ?? 0}`} device={device} incident={incident} onClearDevice={clear} onClearIncident={clear} />
  },
})

/* Securitee > GravityZone: protectia statiilor, citita din Bitdefender GravityZone (firmele legate in Settings). */
export const securiteeGravityZoneRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/securitee/gravityzone',
  component: SecuriteeGravityZonePage,
})

/* Securitee > AD accounts: conturile din Active Directory citite pe controlorul de domeniu (numai afisare). */
export const securiteeAdAccountsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/securitee/ad-accounts',
  component: SecuriteeAdAccountsPage,
})

/* Securitee > Local accounts: conturile locale ale masinilor Windows (numai afisare). */
export const securiteeLocalAccountsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/securitee/local-accounts',
  component: SecuriteeLocalAccountsPage,
})

/* Securitee > Email domains: DNS-ul public al domeniilor de mail (SPF, DMARC, DKIM) si FIX. */
export const securiteeEmailDomainsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/securitee/email-domains',
  component: SecuriteeEmailDomainsPage,
})

/* Securitee > Network checks: servicii nesigure vazute de o scanare pornita de om. */
export const securiteeNetworkChecksRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/securitee/network-checks',
  component: SecuriteeNetworkChecksPage,
})

/*
 * Securitee > XDR settings s-a mutat in Settings > Securitee, fila XDR (6
 * octombrie 2026). Adresa veche ramane, ca o legatura pastrata sa nu dea
 * Not Found - numai redirect, fara ecran.
 */
export const securiteeXdrSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/securitee/xdr_settings',
  beforeLoad: () => {
    throw redirect({ to: '/settings/securitee/$tab', params: { tab: 'xdr' } })
  },
})

export const securiteeDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/securitee/dashboard',
  component: function SecuriteeModuleBoard() {
    return <ModuleBoardPage query={(s) => moduleBoardQuery('securitee', s)} basePath="/app/securitee/dashboard" />
  },
})

/** Protectee, in /app de pe 12 septembrie 2026: tabloul de modul si All Devices. `index` -> all_devices. */
export const protecteeIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/protectee',
  beforeLoad: () => {
    throw redirect({ to: '/protectee/all_devices' })
  },
})

export const protecteeDevicesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/protectee/all_devices',
  component: ProtecteeDevicesPage,
})

/*
 * Tabloul de MODUL, de pe 18 septembrie 2026 - acelasi ecran ca la Softsee,
 * Opteemum si celelalte, cu cardurile de backup din catalog. Pana atunci aici
 * statea ecranul cu patru contoare, si banda de module a tabloului central
 * ducea fix la el: Protectee era singurul modul care nu arata ca celelalte.
 *
 * Cele patru cifre ale ecranului vechi (aparate, furate, in sediul principal,
 * cu backup) sunt carduri in catalog (`Catalog::protecteeCards`), primele din
 * grila. Ecranul cu contoare, tinut o zi la `/protectee/classic`, s-a sters
 * (decizia Roxanei, 18 septembrie 2026).
 */
export const protecteeDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/protectee/dashboard',
  component: function ProtecteeModuleBoard() {
    return <ModuleBoardPage query={(s) => moduleBoardQuery('protectee', s)} basePath="/app/protectee/dashboard" />
  },
})

/** Printeeng, in /app de pe 12 septembrie 2026: tabloul de modul, All Devices, Printers, Events. `index` -> dashboard, ca `Printeeng::index`. */
export const printeengIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/printeeng',
  beforeLoad: () => {
    throw redirect({ to: '/printeeng/dashboard' })
  },
})

export const printeengDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/printeeng/dashboard',
  component: function PrinteengModuleBoard() {
    return <ModuleBoardPage query={(s) => moduleBoardQuery('printeeng', s)} basePath="/app/printeeng/dashboard" />
  },
})

export const printeengDevicesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/printeeng/all_devices',
  component: PrinteengDevicesPage,
})

export const printeengPrintersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/printeeng/printers',
  component: PrinteengPrintersPage,
})

export const printeengEventsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/printeeng/events',
  component: PrinteengEventsPage,
})

/** Saveenergee, in /app de pe 13 septembrie 2026: Dashboard, All Devices, Events. `index` -> dashboard, ca `Saveenergee::index`. */
export const saveenergeeIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/saveenergee',
  beforeLoad: () => {
    throw redirect({ to: '/saveenergee/dashboard' })
  },
})

export const saveenergeeDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/saveenergee/dashboard',
  component: SaveenergeeDashboardPage,
})

export const saveenergeeDevicesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/saveenergee/all_devices',
  component: SaveenergeeDevicesPage,
})

export const saveenergeeEventsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/saveenergee/events',
  component: SaveenergeeEventsPage,
})

/** Productivitee, in /app de pe 13 septembrie 2026: Dashboard, Device Productivity, User Productivity (pe zi si pe perioada). */
export const productiviteeIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/productivitee',
  beforeLoad: () => {
    throw redirect({ to: '/productivitee/dashboard' })
  },
})

export const productiviteeDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/productivitee/dashboard',
  component: ProductiviteeDashboardPage,
})

export const productiviteeDevicesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/productivitee/device_productivity',
  component: ProductiviteeDevicesPage,
})

export const productiviteeUsersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/productivitee/user_productivity',
  component: ProductiviteeUsersPage,
})

export const productiviteeUsersPeriodRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/productivitee/user_productivity_period',
  component: ProductiviteeUsersPeriodPage,
})

/**
 * Tabloul de conducere (21 septembrie 2026) - singurul ecran al modulului care
 * NU are pereche in portalul vechi. Poarta lui e `productivitee.management`, si
 * bara nu-i deseneaza randul cui n-o are (`Shell::productiviteeNav`).
 */
export const productiviteeManagementRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/productivitee/management',
  component: ProductiviteeManagementPage,
})

/*
 * Raportul de seara al unui OM, deschis din linkul emailului lui - fara cont,
 * fara sesiune, de cele mai multe ori de pe telefon.
 *
 * Jetonul din adresa e chiar poarta, si e citit pe server. Ruta e in
 * `barePages.ts` de amandoua partile: fara schelet (omul n-ar avea ce face cu
 * o bara de module pe care n-o poate deschide) si fara ceasul de reinnoire a
 * sesiunii, fiindca n-are ce reinnoi.
 *
 * ADRESA E `my-day`, NU `day_report` - 24 septembrie 2026.
 *
 * Ruta se chema `day_report`, dar scrisoarea n-a scris niciodata cuvantul ala:
 * `DayReportEmail::link()` compune de cand exista `/productivitee/my-day/`.
 * Adica linkul din email dadea 404, si in doua feluri deodata - alt cuvant, si
 * fara `/app`, basepath-ul aplicatiei. Roxana a cerut `my-day`, deci ruta se
 * muta pe cuvantul scrisorii, iar scrisoarea isi pune `/app` in fata.
 *
 * Redenumirea e sigura fiindca nu exista niciun link viu: tabelul de jetoane
 * (`it_productivitee_day_report_tokens`, migrarea `Version20260921170000`) nu e
 * inca facut pe instanta, deci n-a plecat niciodata vreun jeton. De aici
 * incolo NU se mai poate: adresa ajunge in mesaje care stau in casute
 * saptamani intregi, si nu se mai schimba dupa ce a plecat primul email.
 *
 * Sta DUPA celelalte rute ale modulului, dar asta nu conteaza: `my-day` e un
 * segment static, si niciuna dintre ele nu are parametru pe locul lui.
 */
export const productiviteeDayReportRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/productivitee/my-day/$token',
  /*
   * `?gap=HH:MM` - CARE BUCATA DE TIMP NEURMARIT SE DESCHIDE.
   *
   * Scrisoarea de seara scrie cate un link pe fiecare bucata
   * (`DayReportEmail::gapLink()`), ca omul sa cada drept pe cea pe care a
   * apasat, nu in capul unei pagini pe care mai trebuie sa o caute - mai ales
   * pe telefon, unde bucatile pot fi sub primul cadru.
   *
   * CHEIA E CEASUL DE INCEPUT, nu numarul de ordine al bucatii. Ordinea se
   * schimba intre doua treceri ale cronului - agentul mai trimite randuri
   * pentru ziua in curs, doua taceri se leaga intr-una, una deja lamurita iese
   * din lista - si atunci un `?gap=2` dintr-un email de ieri ar deschide azi cu
   * totul alt ceas. Ceasul e ce vede omul scris pe rand, si e chiar cheia pe
   * care raspunsul serverului o poarta pe fiecare gol (`DayGap.start`).
   *
   * Ce nu se potriveste cu nimic nu strica nimic: pagina se deschide normal.
   * Vezi `DayReportPage`.
   */
  validateSearch: (search: Record<string, unknown>): { gap?: string } => ({
    gap: typeof search.gap === 'string' && search.gap !== '' ? search.gap : undefined,
  }),
  component: function ProductiviteeDayReportScreen() {
    const { token } = productiviteeDayReportRoute.useParams()
    const { gap } = productiviteeDayReportRoute.useSearch()

    return <DayReportPage token={token} gap={gap} />
  },
})

export const softseeDeviceBareRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/softsee/device',
  component: function SoftseeDeviceBare() {
    return <SoftseeDevicePage id={undefined} />
  },
})

export const softseeDeviceRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/softsee/device/$id',
  component: function SoftseeDevice() {
    const { id } = softseeDeviceRoute.useParams()
    return <SoftseeDevicePage id={id} />
  },
})

/**
 * Static /proactivitee/alarms beats /proactivitee/$page so the fleet
 * alarms screen stays AlarmFleetPage (same URL as /$door/alarms).
 */
export const proactiviteeAlarmsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/proactivitee/alarms',
  component: function ProactiviteeAlarmsPage() {
    return <AlarmFleetPage door="proactivitee" />
  },
})

export const proactiviteeDeviceIdRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/proactivitee/device/$id',
  component: function ProactiviteeDeviceIdPage() {
    const { id } = proactiviteeDeviceIdRoute.useParams()
    return <ProactiviteeDevicePage id={id} />
  },
})

export const proactiviteeDeviceRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/proactivitee/device',
  component: function ProactiviteeDeviceBarePage() {
    return <ProactiviteeDevicePage id={undefined} />
  },
})

export const proactiviteeDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/proactivitee/dashboard',
  component: function ProactiviteeModuleBoard() {
    return <ModuleBoardPage query={(s) => moduleBoardQuery('proactivitee', s)} basePath="/app/proactivitee/dashboard" />
  },
})

/**
 * Prezenta tehnicienilor - `Dashboards::onsite_presence`. Adresa e cea din
 * portal (`dashboards/onsite_presence`); dreptul e al lui Proactivitee, si
 * `header_menu/dashboards.php` spune ca "ramane unde era".
 */
export const dashboardsOnsitePresenceRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dashboards/onsite_presence',
  component: OnsitePresencePage,
})

export const proactiviteeSnmpDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/proactivitee/snmp_dashboard',
  component: SnmpDashboardPage,
})

export const proactiviteeSnmpServicesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/proactivitee/snmp_services',
  component: SnmpServicesPage,
})

export const proactiviteeSnmpHostsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/proactivitee/snmp_host_monitoring',
  component: SnmpHostsPage,
})

export const proactiviteeCoreApplicationsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/proactivitee/core_applications',
  component: CoreApplicationsPage,
})

export const proactiviteeCoreApplicationsDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/proactivitee/core_applications_dashboard',
  component: CoreApplicationsDashboardPage,
})

export const proactiviteeApplicationsDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/proactivitee/applications_dashboard',
  component: ApplicationsDashboardPage,
})

export const proactiviteePageRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/proactivitee/$page',
  beforeLoad: ({ params }) => {
    if (!isProactiviteePage(params.page)) {
      throw redirect({ to: '/proactivitee/$page', params: { page: 'all_devices' } })
    }
  },
  component: function ProactiviteeListPage() {
    const { page } = proactiviteePageRoute.useParams()
    return <ProactiviteeDeviceListPage list={proactiviteeListOf(isProactiviteePage(page) ? page : 'all_devices')} />
  },
})

export const dashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dashboard',
  component: function PlatformDashboard() {
    return <DashboardPage />
  },
})

export const dashboardBoardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dashboard/board/$id',
  component: function PlatformBoard() {
    const { id } = dashboardBoardRoute.useParams()
    return <DashboardPage boardId={Number(id)} />
  },
})

/*
 * `/dashboard/module/<modul>` - ADRESA RETRASA, care acum duce mai departe.
 *
 * -----------------------------------------------------------------------------
 * DE CE EXISTA, DACA AM PARASIT-O DINADINS
 * -----------------------------------------------------------------------------
 *
 * Fiindca am impartit-o noi. In portal e adresa proprie a lui
 * `Dashboard::module`, si `Catalog::boardUrl()` o da si azi oricarui modul care
 * n-are rand in `application/config/routes.php` - iar fisierul ala e stratul
 * comun, incarcat si de portalul bancii, unde adresa CHIAR merge. Deci ea sta
 * in semne de carte, in mailuri si in legaturi trimise deja.
 *
 * Tabloul modulului NU se intoarce sub `dashboard/...`: antetul si meniul
 * lateral aleg modulul dupa PRIMUL segment al adresei, deci acolo omul pierdea
 * meniul modulului si vedea "Overview" sus - "dispare si meniul si tot", 10
 * septembrie 2026. Ruta asta nu deseneaza nimic; duce omul la tabloul
 * modulului, sub adresa modulului, cu meniul lui intreg.
 *
 * Un nume necunoscut cade pe tabloul central, ca in `Dashboard::module` din
 * portal - nu pe un ecran gol care pare stricat.
 */
const MODULE_BOARD = {
  overview: '/dashboard',
  inventoree: '/inventoree/dashboard',
  softsee: '/softsee/dashboard',
  opteemum: '/opteemum/dashboard',
  proactivitee: '/proactivitee/dashboard',
  easeedesk: '/easeedesk/dashboard',
  securitee: '/securitee/dashboard',
  printeeng: '/printeeng/dashboard',
  protectee: '/protectee/dashboard',
  /*
   * Productivitee si Saveenergee lipseau de aici, si lipsa lor se vedea exact
   * ca defectul pentru care s-a scris ruta: `dashboard/module/productivitee`
   * cadea pe `/dashboard`, adica pe tabloul central - unde antetul si bara se
   * aleg dupa PRIMUL segment al adresei, deci scria "Overview" sus si bara
   * purta intrarile lui Overview. Omul pleca spre Productivitee si ajungea
   * intr-un modul in care nu intrase, fara niciuna din filele lui.
   *
   * Si sunt chiar modulele pe care portalul le trimite prin adresa retrasa:
   * `Catalog::boardUrl()` da `<modul>/dashboard` numai pentru
   * `Catalog::$routed`, iar niciunul din cele doua nu e acolo.
   *
   * Lista de aici sunt TOATE modulele cu bara in v4, fara `settings` - vezi
   * `dashboard/moduleBand.test.ts`, care n-o lasa sa ramana in urma.
   */
  productivitee: '/productivitee/dashboard',
  saveenergee: '/saveenergee/dashboard',
} as const

export const dashboardModuleRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dashboard/module/$module',
  beforeLoad: ({ params }) => {
    const to = MODULE_BOARD[params.module as keyof typeof MODULE_BOARD]
    throw redirect({ to: to ?? '/dashboard' })
  },
})

export const dashboardWallRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dashboard/wall/$kind/$key',
  component: function PlatformWall() {
    const { kind, key } = dashboardWallRoute.useParams()
    return <DashboardWall kind={kind} keyName={key} />
  },
})

/*
 * `/monitor/wallboard/<jeton>` - AFISAJUL de perete, deschis de un televizor.
 *
 * Adresa e cea din portal (`Monitor::wallboard($token)`), fiindca ea e cheia:
 * o tabla care sta deja pe un perete n-are de ce s-o piarda. Ce s-a schimbat e
 * doar radacina sub care sta aplicatia (`/app/`).
 *
 * NU ARE SESIUNE SI NU ARE SCHELET. `Shell` o sare cu totul - vezi
 * `ui/barePages.ts` - fiindca antetul, bara de module si alegatorul de firma cer
 * toate un om logat, iar aici nu e niciunul: cheia e adresa. Pagina nu duce
 * nicaieri in aplicatie si nu are nicio actiune.
 *
 * NU ARE RAND IN `MOVED` si nu are intrare in nicio bara de meniu, exact ca
 * ecranul care o emite: la o tabla se ajunge cu adresa ei, nu dintr-un meniu.
 */
export const monitorWallboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/monitor/wallboard/$token',
  component: function WallDisplay() {
    const { token } = monitorWallboardRoute.useParams()

    return <WallboardPage token={token} />
  },
})

export const overviewTodayRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/overview/today',
  component: TodayPage,
})

export const overviewAheadRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/overview/ahead',
  component: AheadPage,
})

export const overviewItilRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/overview/dashboard',
  validateSearch: (search: Record<string, unknown>) => {
    const days = Number(search.days)
    return { days: days === 7 || days === 90 ? days : 30 }
  },
  component: ItilPage,
})

export const overviewDomainsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/overview/domains',
  component: DomainsPage,
})

/*
 * CMDB - Cmdb::index / view / health.
 *
 * Adresele sunt cele din portal, litera cu litera: `/cmdb`, `/cmdb/view/{id}`
 * si `/cmdb/health`. Catre ele trimit legaturi scrise in patru module -
 * Inventoree, Overview, Softsee si Easeedesk - plus bara Overview si cautarea
 * de ecrane. Un ecran mutat la alta adresa e un ecran pe care nu-l gaseste
 * nimeni.
 *
 * `/cmdb/health` sta INAINTEA lui `/cmdb/view/$id` fiindca statice inaintea
 * parametrilor; aici nu se ciocnesc (segmente diferite), dar ordinea ramane cea
 * din restul fisierului.
 */
/*
 * Aplicatiile de business (Overview > Applications): "Charisma ERP" cu
 * serverele pe care sta si oamenii furnizorului. Sunt CI-uri in CMDB, deci
 * poarta banda Overview, ca `/cmdb`.
 */
export const applicationsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/applications',
  /* `?attention=1` (insigna rosie din bara) deschide banda; `?tab=suggested` sugestiile. */
  validateSearch: (search: Record<string, unknown>): { tab?: string; attention?: number } => ({
    tab: typeof search.tab === 'string' ? search.tab : undefined,
    attention: search.attention === undefined ? undefined : Number(search.attention),
  }),
  component: ApplicationsPage,
})

/* Harta aplicatiilor pentru client: statica, deci inainte de `$id`. */
export const applicationMapRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/applications/map',
  component: ApplicationMapPage,
})

/* Furnizorii de suport notati dupa cazurile lor: statica, deci inainte de `$id`. */
export const applicationVendorsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/applications/vendors',
  component: ApplicationVendorsPage,
})

/* Raportul lunar pe aplicatii pentru client: tot static, inainte de `$id`. */
export const applicationMonthlyReportRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/applications/monthly-report',
  component: MonthlyReportPage,
})

export const applicationDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/applications/$id',
  component: function ApplicationDetail() {
    const { id } = applicationDetailRoute.useParams()
    return <ApplicationDetailPage id={Number(id)} />
  },
})

export const cmdbListRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/cmdb',
  component: CmdbListPage,
})

export const cmdbHealthRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/cmdb/health',
  component: CmdbHealthPage,
})

export const cmdbRecordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/cmdb/view/$id',
  component: function CmdbRecord() {
    const { id } = cmdbRecordRoute.useParams()
    return <CmdbRecordPage id={Number(id)} />
  },
})

export const cmdbImportRoute = createRoute({
  getParentRoute: () => rootRoute,
  /* `/cmdb/import`, ca in portal: butonul din lista si semnele de carte ale
     operatorilor duc acolo. Randul din `MOVED` (Shell.tsx) intra odata cu ruta
     asta - fara el, legatura ar pleca spre portalul vechi, care nu mai e pe
     server. */
  path: "/cmdb/import",
  component: CmdbImportPage,
});

export const cmdbBaselinesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/cmdb/baselines',
  component: CmdbBaselinesPage,
})

/*
 * Ferestrele de mentenanta - `Maintenance::index`.
 *
 * La RADACINA, nu sub `/cmdb`, fiindca acolo e si in portal: cele patru vederi
 * ale CMDB-ului stau sub doua controllere de nivel intai, si banda le scrie
 * adresele intregi tocmai de-aia. Ecranul poarta totusi banda CMDB si bara
 * OVERVIEW - `Maintenance::__construct()` isi pune `appModule = 'overview'`.
 */
export const maintenanceRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/maintenance',
  component: MaintenanceWindowsPage,
})

/** `Maintenance::calendar` si `Maintenance::day` - aceleasi ferestre, ca luna si ca zi. */
export const maintenanceCalendarRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/maintenance/calendar',
  component: MaintenanceCalendarPage,
})

export const maintenanceDayRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/maintenance/day',
  component: MaintenanceDayPage,
})

/**
 * Change Proposals - `Changes::index`, la /app/change (routes.php: `change` ->
 * `changes/index`). Calea obisnuita e sertarul din antet; pagina e adresa
 * directa, cu acelasi panou.
 */
export const changeProposalsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/change',
  component: ChangeProposalsPage,
})

export const cmdbBaselineCompareRoute = createRoute({
  getParentRoute: () => rootRoute,
  /* `compareBaseline`, nu `baselines/$id/compare`: fila "State" si fiecare
     rand din lista de fotografii scriu adresa asta, si e cea din portal. */
  path: '/cmdb/compareBaseline/$id',
  component: function CmdbBaselineCompare() {
    const { id } = cmdbBaselineCompareRoute.useParams()
    return <CmdbBaselineComparePage id={Number(id)} />
  },
})

export const overviewNis2Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/overview/nis2',
  component: Nis2Page,
})

/**
 * Problems - `application/controllers/Problems.php`, tot in bara Overview.
 *
 * Adresele sunt cele din portal, litera cu litera: `/problems`,
 * `/problems/candidates` si `/problems/view/{id}`. Catre ele trimit tabloul
 * ITIL, fila Problems a randului desfacut din CMDB, si semnele de carte ale
 * oamenilor - iar portalul vechi nu mai exista pe server, deci o adresa care
 * nu se potriveste aici nu deschide o versiune mai veche a ecranului, ci nimic.
 *
 * `/problems/candidates` sta INAINTEA lui `/problems/view/$id`: statice
 * inaintea celor cu parametru.
 */
export const problemsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/problems',
  component: ProblemsPage,
})

export const problemPatternsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/problems/candidates',
  component: ProblemPatternsPage,
})

export const problemRecordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/problems/view/$id',
  component: function ProblemRecord() {
    const { id } = problemRecordRoute.useParams()
    return <ProblemRecordPage id={Number(id)} />
  },
})

export const overviewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/overview/$page',
  beforeLoad: ({ params }) => {
    if (!isOverviewPage(params.page)) {
      throw redirect({ to: '/overview/$page', params: { page: 'today' } })
    }
  },
  component: function OverviewScreen() {
    const { page } = overviewRoute.useParams()
    if (page === 'today') return <TodayPage />
    if (page === 'ahead') return <AheadPage />
    if (page === 'dashboard') return <ItilPage />
    if (page === 'nis2') return <Nis2Page />
    return <DomainsPage />
  },
})

/*
 * Easeedesk, adus din cele patru benzi lucrate in paralel pe 7 septembrie 2026.
 *
 * Niciunul din cei patru agenti n-a avut voie sa atinga fisierul asta - patru
 * ramuri deschise deodata s-ar fi batut pe el la fiecare ecran nou - deci
 * fiecare a scris in PR-ul lui randurile de adaugat, si se pun aici o singura
 * data, la impacare.
 */

/* Cele doua liste sunt acelasi ecran cu alt cititor, ca in portal:
   `easeedesk/tickets` si `easeedesk/closed_tickets`. */
export const easeedeskTicketsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/$list',
  beforeLoad: ({ params }) => {
    if (!isTicketList(params.list)) {
      throw redirect({ to: '/easeedesk/$list', params: { list: 'tickets' } })
    }
  },
  component: function EaseedeskTicketsScreen() {
    const { list } = easeedeskTicketsRoute.useParams()

    return <TicketListPage list={isTicketList(list) ? list : 'tickets'} />
  },
})

export const easeedeskTicketRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/ticket/$id',
  component: function EaseedeskTicketScreen() {
    const { id } = easeedeskTicketRoute.useParams()

    return <TicketPage id={id} />
  },
})

/*
 * Fila ceruta prin adresa: `/app/easeedesk/ticket/4711/summary-tab`.
 *
 * In portal, al doilea argument al lui `Easeedesk::ticket($ticket, $tab)` e
 * chiar id-ul elementului de fila, iar macheta il apasa cu javascript dupa ce
 * randul extins ajunge pe ecran. `TicketPage` stie de mult sa deschida fila
 * ceruta (`startingTab`), si `api/easeedesk.ts` scrie chiar adresa asta in
 * comentariu - dar ruta nu era pusa in arbore, deci nimeni nu putea sa i-o dea:
 * legaturile din portal catre o fila anume se pierdeau, si prima fila castiga
 * mereu.
 */
export const easeedeskTicketTabRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/ticket/$id/$tab',
  component: function EaseedeskTicketTabScreen() {
    const { id, tab } = easeedeskTicketTabRoute.useParams()

    return <TicketPage id={id} tab={tab} />
  },
})

/* `easeedesk/dashboard`: in CI3 ruta duce la `Dashboard::module('easeedesk')`,
   nu la `Easeedesk::dashboard`. Sta INAINTEA lui `/easeedesk/$list`, ca sa nu
   fie inghitita de el ca nume de lista. */
export const easeedeskDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/dashboard',
  component: EaseedeskDashboardPage,
})

/*
 * DOUA ecrane poarta numele "My Performance" in portal, si nu e o batere de
 * adrese, ci doua bucati din acelasi loc:
 *
 *  - `easeedesk/my_performance` duce, prin `routes.php:137`, la
 *    `easeedesk-dashboards/My_performance` - TABLOUL, cel din meniu. El ia
 *    adresa scurta, aici ca si acolo;
 *  - `easeedesk/my_performance/completion_time` duce la
 *    `easeedesk-reports/My_performance::completion_time` - RAPORTUL, care in
 *    portal se deschidea din coloana ecranului `Easeedesk::my_performance`.
 *    Ecranul ala a ramas fara adresa proprie (nicio ruta nu mai ajunge la el),
 *    dar raportul lui e viu si are ruta lui - deci coloana sta pe adresa
 *    raportului, exact cea din portal.
 */
export const easeedeskMyPerformanceRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/my_performance',
  component: MyPerformanceDashboardPage,
})

export const easeedeskCompletionTimeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/my_performance/completion_time',
  component: MyPerformancePage,
})

/*
 * Al treilea ecran cu "performance" in nume: tabloul cu PUNCTE (LTP). Nu e in
 * meniu nici in portal - se ajunge la el din butonul "My LTP" din All Reports
 * -, dar are ruta lui in `routes.php:138`, si o pastreaza.
 */
export const easeedeskMyNewPerformanceRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/my_new_performance',
  component: NewPerformancePage,
})

export const easeedeskItSolutionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/it_solutions',
  component: ItSolutionsPage,
})

/* Biblioteca furnizorului - `solutions/categories`, deschisa din "Master Edit". */
export const solutionsCategoriesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/solutions/categories',
  component: SolutionsCategoriesPage,
})

export const easeedeskItPoliciesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/it_policies',
  component: ItPoliciesPage,
})

export const easeedeskTicketsDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/tickets_dashboard',
  component: TicketsDashboardPage,
})

export const easeedeskAllReportsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/all_reports',
  component: AllReportsPage,
})

export const easeedeskOncallRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/oncall',
  component: OncallPage,
})

/* Aprobarea managerului solicitantului pe un pas de flux: ce asteapta
   hotararea omului logat. Ecran nou, numai in v4; aici duce clopotelul. */
export const easeedeskApprovalsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/approvals',
  component: AwaitingApprovalPage,
})

/* Change management: sedintele CAB - lista si sedinta. Ecrane noi, numai in v4. */
export const easeedeskCabMeetingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/cab_meetings',
  component: CabMeetingsPage,
})

export const easeedeskCabMeetingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/cab_meetings/$id',
  component: CabMeetingDetail,
})

function CabMeetingDetail() {
  const { id } = easeedeskCabMeetingRoute.useParams()
  /* `key`: alta sedinta = alt formular, nu campurile celei de dinainte. */
  return <CabMeetingPage key={id} id={Number(id) || 0} />
}

export const easeedeskCustomersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/customers',
  component: CustomersPage,
})

export const easeedeskGpsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/gps_tracking',
  component: GpsTrackingPage,
})

/*
 * Tichetul vazut de CLIENT, deschis din linkul unui email - fara sesiune.
 *
 * Jetonul e chiar poarta, si e verificat pe server, la fel ca in portal. Ruta
 * poarta acelasi nume ca adresa veche (`easeedesk/customer_ticket_details/<jeton>`)
 * ca linkurile deja trimise sa duca in acelasi loc.
 */
/*
 * Confirmarea citirii unei politici IT, din emailul angajatului - fara sesiune
 * (`barePages.ts`). Jetonul e cheia, cautat pe server dupa sha256.
 */
export const easeedeskPolicyAckRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/policy-ack/$token',
  component: function EaseedeskPolicyAckScreen() {
    const { token } = easeedeskPolicyAckRoute.useParams()

    return <PolicyAckPage token={token} />
  },
})

export const easeedeskCustomerTicketRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/customer_ticket_details/$token',
  component: function EaseedeskCustomerTicketScreen() {
    const { token } = easeedeskCustomerTicketRoute.useParams()

    return <CustomerTicketPage token={token} />
  },
})

/** Tichetul biroului — jeton `page` din email (F2), nu id cifrat. */
export const deskTicketRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/desk/ticket/$token',
  component: function DeskTicketScreen() {
    const { token } = deskTicketRoute.useParams()

    return <DeskTicketPage token={token} />
  },
})

export const deskAnswerRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/desk/answer/$token/$answer',
  component: function DeskAnswerScreen() {
    const { token, answer } = deskAnswerRoute.useParams()

    return <DeskAnswerPage token={token} answer={answer} />
  },
})

export const deskConfirmRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/desk/confirm/$token',
  component: function DeskConfirmScreen() {
    const { token } = deskConfirmRoute.useParams()

    return <DeskConfirmPage token={token} />
  },
})

export const deskApproveRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/desk/approve/$token',
  component: function DeskApproveScreen() {
    const { token } = deskApproveRoute.useParams()

    return <DeskApprovePage token={token} />
  },
})

export const deskConsentRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/desk/consent/$token',
  component: function DeskConsentScreen() {
    const { token } = deskConsentRoute.useParams()

    return <DeskConsentPage token={token} />
  },
})

/*
 * Celelalte trei pagini deschise din linkul unui email, tot fara sesiune:
 * respingerea unei planificari, redeschiderea unui tichet rezolvat, si parerea
 * clientului dupa rezolvare.
 *
 * ADRESELE SUNT CELE VECHI, cuvant cu cuvant. Linkurile au plecat deja prin
 * email si nu se mai pot schimba - o adresa noua ar face ca tot ce s-a trimis
 * pana azi sa duca in gol. De-aia raman `reject_planned_ticket`,
 * `reopen_resolved_ticket` si `ticket_feedback`, cu tot cu liniuta de jos.
 */
export const easeedeskRejectPlanningRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/reject_planned_ticket/$token',
  component: function EaseedeskRejectPlanningScreen() {
    const { token } = easeedeskRejectPlanningRoute.useParams()

    return <RejectPlanningPage token={token} />
  },
})

export const easeedeskReopenResolvedRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/reopen_resolved_ticket/$token',
  component: function EaseedeskReopenResolvedScreen() {
    const { token } = easeedeskReopenResolvedRoute.useParams()

    return <ReopenResolvedPage token={token} />
  },
})

export const easeedeskTicketFeedbackRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/ticket_feedback/$token/$rating',
  component: function EaseedeskTicketFeedbackScreen() {
    const { token, rating } = easeedeskTicketFeedbackRoute.useParams()

    return <TicketFeedbackPage token={token} rating={Number(rating)} />
  },
})

/*
 * Aprobarea si respingerea unui tichet din linkul unui email - adresele cerute
 * in `routes.php`: `easeedesk/ticket/approve/<jeton>` si `.../deny/<jeton>`.
 *
 * Au ACELASI NUMAR DE SEGMENTE ca fila unui tichet (`/easeedesk/ticket/$id/$tab`),
 * si asta e in regula: `approve` si `deny` sunt segmente STATICE, iar routerul
 * pune intotdeauna staticul inaintea parametrului. In portal grija era aceeasi,
 * doar ca acolo se rezolva prin ordinea randurilor din `routes.php`.
 */
export const easeedeskTicketApproveRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/ticket/approve/$token',
  component: function EaseedeskTicketApproveScreen() {
    const { token } = easeedeskTicketApproveRoute.useParams()

    return <TicketApprovalPage action="approve" token={token} />
  },
})

export const easeedeskTicketDenyRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/ticket/deny/$token',
  component: function EaseedeskTicketDenyScreen() {
    const { token } = easeedeskTicketDenyRoute.useParams()

    return <TicketApprovalPage action="deny" token={token} />
  },
})

/*
 * Escaladarea interna, acceptata sau respinsa din linkul emailului -
 * `easeedesk/accept_escalated_ticket/<jeton>` si `reject_escalated_ticket/<jeton>`,
 * adresele pe care le scrie API-ul telefonului in emailuri. Spre deosebire de
 * cele de mai sus, NU sunt pagini fara schelet: omul e un coleg cu cont, si
 * jetonul e legat de contul lui (`EscalationLinks`) - deci raman sub `Shell`,
 * si nu intra in `barePages.ts`. Pana la rutele astea, cele doua adrese dadeau
 * 404 in /app, si emailurile de escaladare duceau in gol.
 */
export const easeedeskAcceptEscalationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/accept_escalated_ticket/$token',
  component: function EaseedeskAcceptEscalationScreen() {
    const { token } = easeedeskAcceptEscalationRoute.useParams()

    return <AcceptEscalationPage token={token} />
  },
})

export const easeedeskRejectEscalationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/reject_escalated_ticket/$token',
  component: function EaseedeskRejectEscalationScreen() {
    const { token } = easeedeskRejectEscalationRoute.useParams()

    return <RejectEscalationPage token={token} />
  },
})

/*
 * Tablourile Easeedesk. Adresa fiecaruia e CEA DIN PORTAL, si portalul are
 * doua feluri de adrese aici:
 *
 * - cele cu scurtatura in `routes.php` stau la `easeedesk/dashboards/<ecran>`
 *   (group_users_tickets, users_tickets, tds_performance_dashboard cu cele
 *   patru de sub el);
 * - restul se cheama direct pe directorul lor de controllere,
 *   `easeedesk-dashboards/<ecran>` - asa le scriu si legaturile din All
 *   Reports (`quick_support`, `leader_board`, `sku`, `odp_workorder`).
 *
 * Nu se alege una din ele pentru toate: adresa din /app trebuie sa fie ACEEASI
 * cu cea din portal, altfel redirectarea n-are ce mapa si un semn de carte
 * vechi cade in 404.
 */
export const easeedeskQuickSupportRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk-dashboards/quick_support',
  component: QuickSupportPage,
})

export const easeedeskLeaderBoardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk-dashboards/leader_board',
  component: LeaderBoardPage,
})

/*
 * Cele patru ecrane TDS. In portal:
 * `easeedesk/dashboards/tds_performance_dashboard` si cele trei sub el.
 */
export const easeedeskTdsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/dashboards/tds_performance_dashboard',
  component: function EaseedeskTdsScreen() {
    return <RegionSkuPage kind="all" />
  },
})

export const easeedeskTdsNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/dashboards/tds_performance_dashboard/new_pc_services',
  component: function EaseedeskTdsNewScreen() {
    return <RegionSkuPage kind="new" />
  },
})

export const easeedeskTdsExistingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/dashboards/tds_performance_dashboard/existing_pc_services',
  component: function EaseedeskTdsExistingScreen() {
    return <RegionSkuPage kind="existing" />
  },
})

export const easeedeskTdsAllSkuRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/dashboards/tds_performance_dashboard/all_sku',
  component: function EaseedeskTdsAllSkuScreen() {
    return <RegionSkuPage kind="all_sku" />
  },
})

/* In portal: `easeedesk/dashboards/group_users_tickets`. */
export const easeedeskGroupUsersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/dashboards/group_users_tickets',
  component: GroupUsersPage,
})

export const easeedeskUsersTicketsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/dashboards/users_tickets',
  component: UsersTicketsPage,
})

export const easeedeskSkuDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk-dashboards/sku',
  component: SkuDashboardPage,
})

export const easeedeskOdpWorkorderRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk-dashboards/odp_workorder',
  component: OdpWorkorderPage,
})

/* In portal: `easeedesk/dashboards/tds_performance_dashboard/remarketing`. */
export const easeedeskRemarketingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/easeedesk/dashboards/tds_performance_dashboard/remarketing',
  component: RemarketingPage,
})

/*
 * Cele patru file de setari Easeedesk. Adresa e cea a metodei din
 * `application/controllers/settings/Easeedesk.php`, cu tot cu sufixul
 * `_settings` pe trei din ele - asa le scriu legaturile din
 * `views/version-3/easeedesk_settings/`. Doar `ticket_custom_fields` n-are
 * sufix, si tot fara ramane.
 *
 * Capetele de api (`/api/v2/settings/easeedesk/ticket_categories`) sunt alt
 * spatiu de nume si nu se ating: acolo numele e al resursei, nu al adresei
 * din portal.
 */
export const settingsEaseedeskCategoriesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/ticket_categories_settings',
  component: TicketCategoriesPage,
})

export const settingsEaseedeskPrioritiesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/ticket_priorities_settings',
  component: TicketPrioritiesPage,
})

export const settingsEaseedeskSubcategoriesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/ticket_subcategories_settings',
  component: TicketSubcategoriesPage,
})

export const settingsEaseedeskCustomFieldsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/ticket_custom_fields',
  component: TicketCustomFieldsPage,
})

/* Repartizarea pe echipe. In portal, `group_dispatching`, fara sufix. */
export const settingsEaseedeskGroupDispatchingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/group_dispatching',
  component: GroupDispatchingPage,
})

/* Rutarea dupa sediul celui care cere. Ecran nou, numai in v4. */
export const settingsEaseedeskOfficeRoutingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/office_routing',
  component: OfficeRoutingPage,
})

/* Repartizarea pe email. In portal, `ticket_dispatching`, fara sufix. */
export const settingsEaseedeskTicketDispatchingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/ticket_dispatching',
  component: TicketDispatchingPage,
})

/* Actiunile recomandate din chat. In portal, `chat_recommended_actions`. */
export const settingsEaseedeskChatActionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/chat_recommended_actions',
  component: ChatRecommendedActionsPage,
})

/* Comentariile automate. In portal, `auto_comments_settings`. */
export const settingsEaseedeskAutoCommentsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/auto_comments_settings',
  component: AutoCommentsPage,
})

/* Felurile de comentariu. In portal, `comments_settings`. */
export const settingsEaseedeskCommentTypesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/comments_settings',
  component: CommentTypesPage,
})

/* Serverele de email ale notificarilor. In portal, `email_server_settings`. */
export const settingsEaseedeskEmailServersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/email_server_settings',
  component: EmailServersPage,
})

/* Notificarile din portal. In portal, `portal_notifications_settings`. */
export const settingsEaseedeskPortalNotificationsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/portal_notifications_settings',
  component: PortalNotificationsPage,
})

/* Notificarile agentului. In portal, `agent_notifications_settings`. */
export const settingsEaseedeskAgentNotificationsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/agent_notifications_settings',
  component: AgentNotificationsPage,
})

/*
 * Instiintarile pe email si pe telefon. In portal, `notifications_settings` si
 * `mobile_notifications_settings` - randurile scrise de aici sunt chiar cele pe
 * care le citeste coada de instiintari a tichetelor.
 */
export const settingsEaseedeskNotificationsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/notifications_settings',
  component: NotificationsPage,
})

export const settingsEaseedeskMobileNotificationsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/mobile_notifications_settings',
  component: MobileNotificationsPage,
})

/*
 * Cele sase ecrane Adam Intop din setarile Easeedesk. Adresa e a metodei din
 * `application/controllers/settings/Easeedesk.php`, litera cu litera - asa le
 * scriu legaturile din meniul de setari.
 *
 * `edit_python_file`, `edit_extended_module` si `edit_file_hierarchy` NU au
 * adresa proprie: in portal erau file aduse prin ajax intr-un rand desfasurat
 * (`python_file_tabs`, `extended_module_tabs`), si aici sunt chiar panoul
 * randului. Ecranul de Dialogflow lipseste fiindca e in alt grup din harta,
 * inca nemutat.
 */
export const settingsEaseedeskAdamIntopRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/adam_intop_settings',
  component: AdamIntopSettingsPage,
})

export const settingsEaseedeskAdamIntopScenariosRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/adam_intop_scenarios',
  component: AdamIntopScenariosPage,
})

/* Adam Intop > DialogFlow Settings - `Easeedesk::adam_intop_dialogflow_settings`. */
export const settingsEaseedeskAdamIntopDialogflowRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/adam_intop_dialogflow_settings',
  component: AdamIntopDialogflowPage,
})

/* Adam Intop > Adam Cron Settings - `Easeedesk::adam_intop_cron_stucked_tickets`. */
export const settingsEaseedeskAdamIntopCronRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/adam_intop_cron_stucked_tickets',
  component: AdamIntopCronPage,
})

/* Adam Intop > Populate Default Analyser Actions Details - `Easeedesk::populate_default_actions_details`. */
export const settingsEaseedeskAdamIntopDefaultsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/populate_default_actions_details',
  component: AdamIntopDefaultActionsPage,
})

/*
 * Easeedesk > AI Analizer Actions. Adresele sunt cele din bara
 * (`EaseedeskSettingsMenu`): `settings/diagnostic/...`, controllerul vechi
 * `settings/Diagnostic`, nu `Diagnostic_reports` (alt hub, alt ecran).
 */
export const settingsDiagnosticActionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/diagnostic/actions',
  component: QuickDiagnosticActionsPage,
})

export const settingsDiagnosticTopUsersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/diagnostic/ai_analizer_top_users',
  component: AiTopUsersPage,
})

export const settingsDiagnosticAiAnalizerRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/diagnostic/ai_analizer_actions',
  component: AiAnalizerActionsPage,
})

export const settingsEaseedeskAdamIntopPythonFilesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/adam_intop_python_files',
  component: AdamIntopPythonFilesPage,
})

export const settingsEaseedeskAdamIntopModulesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/adam_intop_extended_modules',
  component: AdamIntopExtendedModulesPage,
})

export const settingsEaseedeskAdamIntopCleanRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/clean_removed_actions',
  component: AdamIntopCleanActionsPage,
})

export const settingsEaseedeskAdamIntopAssignRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/assign_company_actions',
  component: AdamIntopAssignCompanyPage,
})

/* Notificari: sabloanele de email. In portal, `email_templates_settings`. */
export const settingsEaseedeskEmailTemplatesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/email_templates_settings',
  component: EmailTemplatesPage,
})

/* Notificari: sabloanele de telefon. In portal, `mobile_templates_settings`. */
export const settingsEaseedeskMobileTemplatesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/mobile_templates_settings',
  component: MobileTemplatesPage,
})

/* Notificari: sabloanele emailului catre furnizor ("Waiting for Third Party").
   Numai in v4 - aceeasi tabela cu sabloanele de email, `template_kind`. */
export const settingsEaseedeskThirdPartyTemplatesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/third_party_templates_settings',
  component: ThirdPartyTemplatesPage,
})

export const settingsEaseedeskTicketGeneralRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/ticket_general_settings',
  component: TicketGeneralSettingsPage,
})

export const settingsEaseedeskQuickFiltersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/quick_filters',
  component: QuickFiltersPage,
})

export const settingsEaseedeskQuickFiltersGroupsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/quick_filters_groups',
  component: QuickFiltersGroupsPage,
})

export const settingsEaseedeskChatRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/chat_settings',
  component: ChatSettingsPage,
})

export const settingsEaseedeskChatMessagesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/chat_languages_messages',
  component: ChatMessagesPage,
})

export const settingsEaseedeskFastDispatchRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/fast_dispatch',
  component: FastDispatchPage,
})

/* In portal adresa e chiar numele metodei, in camelCase: `sampleComments`. */
export const settingsEaseedeskSampleCommentsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/sampleComments',
  component: SampleCommentsPage,
})

export const settingsEaseedeskPredefinedMessagesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/chat_predefined_messages',
  component: PredefinedMessagesPage,
})

export const settingsEaseedeskCollaborateTemplatesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/collaborate_template_messages',
  component: CollaborateTemplatesPage,
})

export const settingsEaseedeskWorkflowsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/workflow_settings',
  component: WorkflowSettingsPage,
})

/* Change management (CEC L30, L31): grupurile CAB, chestionarul de risc si
   pragurile. Ecran nou, numai in v4 - n-are pereche in portalul vechi. */
export const settingsEaseedeskChangeManagementRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/change_management',
  component: ChangeManagementPage,
})

export const settingsEaseedeskSkusRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/skus_list',
  component: SkusPage,
})

export const settingsEaseedeskSkuCommandsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/commands_list',
  component: SkuCommandsPage,
})

/*
 * Constructorul de formulare. Adresa e cea din bara
 * (`easeedesk_settings/index.php`), fara sufixul `_settings`.
 */
export const settingsEaseedeskFormBuilderRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/ticket_form_builder',
  component: TicketFormBuilderPage,
})

/*
 * `new_ticket_form_builder` era ACELASI ecran, peste aceleasi date, cu alt
 * drept (20 octombrie 2026: scos). Adresa ramane, ca semnele de carte sa
 * mearga, si trimite la constructorul de formulare - unde dreptul filei vechi
 * deschide in continuare formularele (`EaseedeskFormBuilder::canBuild()`).
 */
export const settingsEaseedeskNewFormBuilderRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/new_ticket_form_builder',
  beforeLoad: () => {
    throw redirect({ to: '/settings/easeedesk/ticket_form_builder', replace: true })
  },
})

/* `reopen_ticket` n-are sufix nici in portal, si tot fara ramane. */
export const settingsEaseedeskReopenRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/reopen_ticket',
  component: ReopenTicketPage,
})

/* Others > Oncall - `Easeedesk::oncall`, adresa literala din bara. */
export const settingsEaseedeskOncallRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/oncall',
  component: OncallSettingsPage,
})

/* Automated User - `Easeedesk::automated_user_settings`. */
export const settingsEaseedeskAutomatedUserRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/automated_user_settings',
  component: AutomatedUserPage,
})

/* Planning - `Easeedesk::planning_settings`. */
export const settingsEaseedeskPlanningRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/planning_settings',
  component: PlanningSettingsPage,
})

/* Workflows > Assigning workflows - `Easeedesk::assigning_workflows`. */
export const settingsEaseedeskAssigningWorkflowsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/assigning_workflows',
  component: AssigningWorkflowsPage,
})

/* Tickets > Ticket form configuration - `Easeedesk::ticket_form_configuration`. */
export const settingsEaseedeskFormConfigurationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/ticket_form_configuration',
  component: TicketFormConfigurationPage,
})

/* External service providers - `Easeedesk::external_service_providers`. */
export const settingsEaseedeskExternalProvidersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/external_service_providers',
  component: ExternalProvidersPage,
})

export const settingsEaseedeskAutoChangeStatusRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/auto_change_status',
  component: AutoChangeStatusPage,
})

export const settingsEaseedeskTriggerChangeStatusRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/trigger_change_status',
  component: TriggerChangeStatusPage,
})

export const settingsEaseedeskStatusRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/ticket_status_settings',
  component: TicketStatusPage,
})

export const settingsEaseedeskSlaRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/sla_settings',
  component: SlaSettingsPage,
})

export const settingsEaseedeskSlaHoursRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/sla_hours',
  component: SlaHoursPage,
})

export const settingsEaseedeskStatusTriggersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/ticket_status_change_trigger_actions',
  component: StatusTriggerActionsPage,
})

export const settingsEaseedeskAssignAutoEscalationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/assigning_auto_escalation',
  component: AssignAutoEscalationPage,
})

export const settingsEaseedeskGroupEscalationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/group_escalation_settings',
  component: GroupEscalationSettingsPage,
})

export const settingsEaseedeskEscalationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/escalation_settings',
  component: EscalationSettingsPage,
})

/*
 * Repartizarea automata in echipa. Sta in portal sub bannerul de escaladare, dar
 * n-are nimic de-a face cu ea: alt drept, alta tabela, alt cache. Adresa e cea
 * din bara, auto_assign.
 */
/*
 * Setarile tabloului de tichete. In portal, metoda se cheama
 * `settings_dashboard_tickets`, iar bara duce la ea cu numele acela.
 */
export const settingsEaseedeskDashboardTicketsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/settings_dashboard_tickets',
  component: DashboardTicketsPage,
})

export const settingsEaseedeskAutoAssignRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/auto_assign',
  component: AutoAssignPage,
})

export const settingsEaseedeskAutoEscalationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/auto_escalation_settings',
  component: AutoEscalationSettingsPage,
})

/* Formularele de ACTUALIZARE: constructorul lor, si legarea de tipuri. */
export const settingsEaseedeskUpdateFormBuilderRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/update_form_builder',
  component: UpdateFormBuilderPage,
})

export const settingsEaseedeskUpdateFormConfigurationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/update_form_configuration',
  component: UpdateFormConfigurationPage,
})

export const settingsEaseedeskFeedbackComplimentsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/feedback_ticket_compliments',
  component: FeedbackComplimentsPage,
})

export const settingsEaseedeskFeedbackRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/feedback_settings',
  component: FeedbackSettingsPage,
})

/*
 * Doua file din grupul Ticket types: cronometrele fiecarui tip, si
 * prioritatile lui. Restul grupului (fisa tipului, constructorul de tip,
 * serviciile, istoricul) e inca in portal.
 */
export const settingsEaseedeskTypeTimersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/ticket_type_timers',
  component: TicketTypeTimersPage,
})

export const settingsEaseedeskTypePrioritiesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/ticket_type_priorities',
  component: TicketTypePrioritiesPage,
})

export const settingsEaseedeskTypeServicesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/ticket_types_services',
  component: TicketTypeServicesPage,
})

export const settingsEaseedeskChangeHistoryRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/settings_change_history',
  component: SettingsChangeHistoryPage,
})

export const settingsEaseedeskTicketTypesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/ticket_types_settings',
  component: TicketTypesPage,
})

/*
 * Ecranul in care un tip GOL se face uitandu-te la el. Adresa e a portalului,
 * cu tipul in cale: `settings/easeedesk/build_type_form/12`.
 */
export const settingsEaseedeskBuildTypeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/build_type_form/$type',
  component: TicketTypeBuildPage,
})

/*
 * Fisa tipului de tichet, cu fila in cale, ca in portal:
 * `settings/easeedesk/ticket_type_overview/12` si `.../12/flow`.
 */
export const settingsEaseedeskTicketTypeSheetRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/ticket_type_overview/$type',
  component: TicketTypeSheetPage,
})

export const settingsEaseedeskTicketTypeSheetPaneRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeedesk/ticket_type_overview/$type/$pane',
  component: TicketTypeSheetPage,
})

/*
 * Self-Service si IT Service Catalog stau la RADACINA, nu sub `/easeedesk/`.
 *
 * In portal sunt controllere de sine statatoare - `base_url()self_service` si
 * `base_url()service_shop`, exact asa le scrie si meniul Easeedesk - iar
 * `header.php` doar le imprumuta banda Easeedesk (`segment(1) ==
 * 'service_shop'`). Adresa din /app trebuie sa fie aceeasi cu cea din portal,
 * altfel legaturile din bara (`Shell::easeedeskNav`) duc in gol.
 *
 * `moduleOf` (api/shell.ts) le trece la Easeedesk, ca bara sa ramana a lor.
 */
export const easeedeskSelfServiceSearchesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/self_service/searches',
  component: SelfServiceSearchesPage,
})

export const easeedeskSelfServiceRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/self_service',
  component: SelfServicePage,
})

export const easeedeskServiceRequestsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/service_shop/requests',
  component: ServiceRequestsPage,
})

export const easeedeskServiceShopRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/service_shop',
  component: ServiceShopPage,
})

/*
 * CATALOGUL DE SERVICII, tot la RADACINA - `Service_catalog` e si el un
 * controller de sine statator in portal, iar `header.php` doar ii imprumuta
 * banda Easeedesk (`segment(1) == 'service_catalog'`).
 *
 * Adresele sunt cele ale portalului, cap la cap, fiindca in ele duc legaturi
 * scrise in ALTE module: meniul Overview (`/service_catalog`), banda
 * magazinului din Easeedesk, "Dashboard Services Costs" din All Reports
 * (`/service_catalog/costsDashboard`), fisa unui element din CMDB
 * (`/service_catalog/costs/{id}`) si fisa unui tip de tichet din setari
 * (`/service_catalog/form/{id}`). Un ecran mutat la alta adresa e un ecran pe
 * care nu-l mai gaseste nimeni.
 *
 * `costsDashboard` se scrie ca in portal, camila cu tot: adresa aia e in meniul
 * de rapoarte si in legaturi deja trimise pe mail.
 */
export const serviceCatalogCostsDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/service_catalog/costsDashboard',
  component: ServiceCatalogCostsDashboardPage,
})

export const serviceCatalogCompositionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/service_catalog/composition/$id',
  component: ServiceCatalogCompositionPage,
})

export const serviceCatalogDependenciesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/service_catalog/dependencies/$id',
  component: ServiceCatalogDependenciesPage,
})

export const serviceCatalogCostsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/service_catalog/costs/$id',
  component: ServiceCatalogCostsEntryPage,
})

export const serviceCatalogFormRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/service_catalog/form/$id',
  component: ServiceCatalogFormPage,
})

export const serviceCatalogRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/service_catalog',
  component: ServiceCatalogPage,
})

export const settingsEaseetaskRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/easeetask',
  component: EaseetaskSettingsPage,
})

export const settingsCompanyReportsEaseedeskRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/company_reports/easeedesk_report',
  component: EaseedeskReportsPage,
})

/* Capul de familie: la el duce "Reports" din bara de setari. */
export const settingsCompanyReportsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/company_reports/index',
  component: CompanyReportsPage,
})

/*
 * Aceeasi pagina si la adresa SCURTA, fara `/index`.
 *
 * In portal, `settings/company_reports` fara metoda cade pe `index()` - asa
 * imparte CodeIgniter adresa - deci si forma scurta deschidea bara de file.
 * In v4 exista doar cea cu `/index`: meniul o scrie intreaga (`SettingsMenu`,
 * si randul din `MOVED` din `ui/Shell`), deci din rotita se ajunge - dar
 * adresa scurta, cea pe care o tine minte omul si cea scrisa in `match`-ul
 * intrarii de meniu, nu potrivea nicio ruta. In locul rapoartelor se deschidea
 * „Not Found", si asta e ce se vede cand cineva cere
 * `/app/settings/company_reports`.
 *
 * Ca la Pass Safe (`passSafeSettingsShortRoute`): a doua ruta cu ACEEASI
 * componenta, nu o redirectare - adresa ramane cea scrisa de om. Filele
 * (`/settings/company_reports/cost_report`...) sunt cai statice mai lungi,
 * deci ruta asta nu le inghite.
 */
export const settingsCompanyReportsShortRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/company_reports',
  component: CompanyReportsPage,
})

export const settingsCompanyReportsScheduledRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/company_reports/scheduled_report',
  component: ScheduledReportsPage,
})

/*
 * Filele pe module ale rapoartelor de firma. Adresa e cea a metodei-pagina din
 * portal (`Company_reports::<modul>_report`); bara de file lega
 * `<modul>_settings_report`, fragmentul AJAX al aceleiasi file.
 */
export const settingsCompanyReportsInventoreeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/company_reports/inventoree_report',
  component: InventoreeReportPage,
})

/*
 * IT Audit - registrul de constatari (`settings/Audit::register`). Adresa e
 * cea din portal; `?all=1` arata si constatarile inchise, ca acolo.
 */
export const settingsAuditRegisterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/audit/register',
  validateSearch: (search: Record<string, unknown>): { all?: number } => ({
    all: search.all === undefined ? undefined : Number(search.all),
  }),
  component: AuditRegister,
})

function AuditRegister() {
  const { all } = settingsAuditRegisterRoute.useSearch()
  return <AuditRegisterPage all={all === 1} />
}

/*
 * IT Audit - fotografia ca document (`settings/Audit::paper`). Adresa e cea
 * din portal; PDF-ul se cere din pagina, nu din `?pdf=1`.
 */
export const settingsAuditPaperRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/audit/paper/$id',
  component: AuditPaper,
})

function AuditPaper() {
  const { id } = settingsAuditPaperRoute.useParams()
  return <AuditPaperPage id={Number(id)} />
}

/*
 * IT Audit - fotografia (`settings/Audit::snapshot`), chestionarul clientului
 * (`::ask`) si briefingul agentului (`::prompts`, 0 = toate auditurile).
 * Adresele sunt cele din portal.
 */
export const settingsAuditSnapshotRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/audit/snapshot/$id',
  component: AuditSnapshot,
})

function AuditSnapshot() {
  const { id } = settingsAuditSnapshotRoute.useParams()
  return <AuditSnapshotPage id={Number(id)} />
}

export const settingsAuditAskRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/audit/ask/$type',
  component: AuditAsk,
})

function AuditAsk() {
  const { type } = settingsAuditAskRoute.useParams()
  return <AuditAskPage type={Number(type)} />
}

export const settingsAuditPromptsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/audit/prompts/$type',
  component: AuditPrompts,
})

function AuditPrompts() {
  const { type } = settingsAuditPromptsRoute.useParams()
  return <AuditPromptsPage type={Number(type) || 0} />
}

/*
 * ADRESELE FARA NUMAR, CA IN PORTAL.
 *
 * `settings/Audit::prompts($id = 0)` raspunde si la `settings/audit/prompts`,
 * fara tip - si exact adresa aia o scriu intrarea „Audit Briefing" din
 * `Services\Navigation\SettingsMenu`, butonul „Briefing" din catalog si
 * redirectarea portalului cand tipul nu exista. Cu ruta numai la
 * `/prompts/$type`, adresa cadea in „Not Found"-ul routerului
 * (15 septembrie 2026).
 *
 * Celelalte patru, fara numar, in portal duc inapoi la catalog
 * (`redirect('settings/audit')`): acelasi lucru aici, nu un „Not Found".
 */
export const settingsAuditPromptsAllRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/audit/prompts',
  component: function AuditPromptsAll() {
    return <AuditPromptsPage type={0} />
  },
})

const toAuditCatalogue = () => {
  throw redirect({ to: '/settings/audit' })
}

export const settingsAuditBareRoutes = (['type', 'snapshot', 'paper', 'ask'] as const).map((what) =>
  createRoute({
    getParentRoute: () => rootRoute,
    path: `/settings/audit/${what}`,
    beforeLoad: toAuditCatalogue,
  }),
)

export const settingsCompanyReportsBiRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/company_reports/bi_report',
  component: BiReportsPage,
})

export const settingsCompanyReportsCostRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/company_reports/cost_report',
  component: CostReportPage,
})

export const settingsCompanyReportsCustomerRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/company_reports/customer_report',
  component: CustomerReportPage,
})

/* Fila "Users Reports": adresa e cea din bara veche (`users_settings_report`). */
export const settingsCompanyReportsUsersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/company_reports/users_settings_report',
  component: UsersReportsPage,
})

export const settingsCompanyReportsPrinteengRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/company_reports/printeeng_report',
  component: PrinteengReportPage,
})

export const settingsCompanyReportsSecuriteeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/company_reports/securitee_report',
  component: SecuriteeReportPage,
})

export const settingsCompanyReportsProductiviteeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/company_reports/productivitee_report',
  component: ProductiviteeReportPage,
})

export const settingsCompanyReportsProactiviteeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/company_reports/proactivitee_report',
  component: ProactiviteeReportPage,
})

export const routeTree = rootRoute.addChildren([
  indexRoute,
  easeedeskDashboardRoute,
  easeedeskCompletionTimeRoute,
  easeedeskMyPerformanceRoute,
  easeedeskMyNewPerformanceRoute,
  easeedeskItSolutionsRoute,
  solutionsCategoriesRoute,
  easeedeskItPoliciesRoute,
  easeedeskTicketsDashboardRoute,
  easeedeskAllReportsRoute,
  easeedeskOncallRoute,
  easeedeskCabMeetingsRoute,
  easeedeskApprovalsRoute,
  easeedeskCabMeetingRoute,
  easeedeskCustomersRoute,
  easeedeskGpsRoute,
  easeedeskCustomerTicketRoute,
  deskTicketRoute,
  deskAnswerRoute,
  deskConfirmRoute,
  deskApproveRoute,
  deskConsentRoute,
  easeedeskPolicyAckRoute,
  easeedeskRejectPlanningRoute,
  easeedeskReopenResolvedRoute,
  easeedeskTicketFeedbackRoute,
  easeedeskTicketApproveRoute,
  easeedeskTicketDenyRoute,
  easeedeskAcceptEscalationRoute,
  easeedeskRejectEscalationRoute,
  easeedeskQuickSupportRoute,
  easeedeskLeaderBoardRoute,
  easeedeskRemarketingRoute,
  easeedeskTdsNewRoute,
  easeedeskTdsExistingRoute,
  easeedeskTdsAllSkuRoute,
  easeedeskTdsRoute,
  easeedeskOdpWorkorderRoute,
  easeedeskSkuDashboardRoute,
  easeedeskUsersTicketsRoute,
  easeedeskGroupUsersRoute,
  easeedeskSelfServiceSearchesRoute,
  easeedeskSelfServiceRoute,
  easeedeskServiceRequestsRoute,
  easeedeskServiceShopRoute,
  serviceCatalogCostsDashboardRoute,
  serviceCatalogCompositionRoute,
  serviceCatalogDependenciesRoute,
  serviceCatalogCostsRoute,
  serviceCatalogFormRoute,
  serviceCatalogRoute,
  easeedeskTicketTabRoute,
  easeedeskTicketRoute,
  easeedeskTicketsRoute,
  settingsEaseedeskCategoriesRoute,
  settingsEaseedeskPrioritiesRoute,
  settingsEaseedeskSubcategoriesRoute,
  settingsEaseedeskCustomFieldsRoute,
  settingsEaseedeskGroupDispatchingRoute,
  settingsEaseedeskOfficeRoutingRoute,
  settingsEaseedeskTicketDispatchingRoute,
  settingsEaseedeskChatActionsRoute,
  settingsEaseedeskAutoCommentsRoute,
  settingsEaseedeskAutoAssignRoute,
  settingsEaseedeskDashboardTicketsRoute,
  settingsEaseedeskCommentTypesRoute,
  settingsEaseedeskEmailServersRoute,
  settingsEaseedeskPortalNotificationsRoute,
  settingsEaseedeskAgentNotificationsRoute,
  settingsEaseedeskNotificationsRoute,
  settingsEaseedeskMobileNotificationsRoute,
  settingsEaseedeskAdamIntopRoute,
  settingsEaseedeskAdamIntopScenariosRoute,
  settingsEaseedeskAdamIntopDialogflowRoute,
  settingsEaseedeskAdamIntopCronRoute,
  settingsEaseedeskAdamIntopDefaultsRoute,
  settingsDiagnosticActionsRoute,
  settingsDiagnosticTopUsersRoute,
  settingsDiagnosticAiAnalizerRoute,
  settingsEaseedeskAdamIntopPythonFilesRoute,
  settingsEaseedeskAdamIntopModulesRoute,
  settingsEaseedeskAdamIntopCleanRoute,
  settingsEaseedeskAdamIntopAssignRoute,
  settingsEaseedeskEmailTemplatesRoute,
  settingsEaseedeskMobileTemplatesRoute,
  settingsEaseedeskThirdPartyTemplatesRoute,
  settingsEaseedeskTicketGeneralRoute,
  settingsEaseedeskFormBuilderRoute,
  settingsEaseedeskNewFormBuilderRoute,
  settingsEaseedeskReopenRoute,
  settingsEaseedeskOncallRoute,
  settingsEaseedeskAutomatedUserRoute,
  settingsEaseedeskPlanningRoute,
  settingsEaseedeskAssigningWorkflowsRoute,
  settingsEaseedeskFormConfigurationRoute,
  settingsEaseedeskExternalProvidersRoute,
  settingsEaseedeskAutoChangeStatusRoute,
  settingsEaseedeskTriggerChangeStatusRoute,
  settingsEaseedeskStatusRoute,
  settingsEaseedeskSlaRoute,
  settingsEaseedeskSlaHoursRoute,
  settingsEaseedeskStatusTriggersRoute,
  settingsEaseedeskAssignAutoEscalationRoute,
  settingsEaseedeskGroupEscalationRoute,
  settingsEaseedeskEscalationRoute,
  settingsEaseedeskAutoEscalationRoute,
  settingsEaseedeskUpdateFormBuilderRoute,
  settingsEaseedeskUpdateFormConfigurationRoute,
  settingsEaseedeskQuickFiltersRoute,
  settingsEaseedeskQuickFiltersGroupsRoute,
  settingsEaseedeskFeedbackComplimentsRoute,
  settingsEaseedeskFeedbackRoute,
  settingsEaseedeskTypeTimersRoute,
  settingsEaseedeskTypePrioritiesRoute,
  settingsEaseedeskTypeServicesRoute,
  settingsEaseedeskChangeHistoryRoute,
  settingsEaseedeskTicketTypesRoute,
  settingsEaseedeskBuildTypeRoute,
  settingsEaseedeskTicketTypeSheetRoute,
  settingsEaseedeskTicketTypeSheetPaneRoute,
  settingsEaseedeskChatRoute,
  settingsEaseedeskChatMessagesRoute,
  settingsEaseedeskFastDispatchRoute,
  settingsEaseedeskSampleCommentsRoute,
  settingsEaseedeskPredefinedMessagesRoute,
  settingsEaseedeskCollaborateTemplatesRoute,
  settingsEaseedeskWorkflowsRoute,
  settingsEaseedeskChangeManagementRoute,
  settingsEaseedeskSkusRoute,
  settingsEaseedeskSkuCommandsRoute,
  settingsEaseetaskRoute,
  settingsCompanyReportsEaseedeskRoute,
  settingsCompanyReportsRoute,
  settingsCompanyReportsShortRoute,
  settingsCompanyReportsScheduledRoute,
  settingsCompanyReportsCustomerRoute,
  settingsCompanyReportsCostRoute,
  settingsCompanyReportsBiRoute,
  settingsCompanyReportsInventoreeRoute,
  settingsAuditRegisterRoute,
  settingsAuditPaperRoute,
  settingsAuditSnapshotRoute,
  settingsAuditAskRoute,
  settingsAuditPromptsRoute,
  settingsAuditPromptsAllRoute,
  ...settingsAuditBareRoutes,
  settingsCompanyReportsUsersRoute,
  settingsCompanyReportsPrinteengRoute,
  settingsCompanyReportsSecuriteeRoute,
  settingsCompanyReportsProductiviteeRoute,
  settingsCompanyReportsProactiviteeRoute,
  inventoreeDashboardRoute,
  inventoreePrintersRoute,
  inventoreeReportsRoute,
  inventoreeLicensesRoute,
  inventoreeUnassignedRoute,
  inventoreeUpgradesRoute,
  inventoreeDiscoveredRoute,
  inventoreeManagedRoute,
  inventoreeMapRoute,
  inventoreeDeviceRoute,
  inventoreeDeviceEmptyRoute,
  inventoreeDeviceCqRoute,
  inventoreeEndpointRoute,
  inventoreeListRoute,
  inventoreeSettingsIndexRoute,
  inventoreeEndpointSettingsRoute,
  inventoreeSettingsTabRoute,
  ciRulesSettingsRoute,
  settingsDirectoryRoute,
  generalSettingsIndexRoute,
  generalSettingsTabRoute,
  companySettingsIndexRoute,
  companyRustdeskMovedRoute,
  companyRustdeskServersMovedRoute,
  companySettingsTabRoute,
  contractsSettingsIndexRoute,
  contractsSettingsTabRoute,
  contractTemplatesSettingsRoute,
  userAccountsSettingsIndexRoute,
  userAccountsSettingsTabRoute,
  myAccountSettingsIndexRoute,
  myAccountSettingsTabRoute,
  licensesSettingsIndexRoute,
  licensesSettingsTabRoute,
  customersSettingsIndexRoute,
  customersSettingsTabRoute,
  customerServicesRoute,
  customerServicePropertiesRoute,
  changeLogSettingsRoute,
  changeLogShortRoute,
  featureRequestsRoute,
  bugReportsRoute,
  contactsSettingsRoute,
  authenticationSettingsRoute,
  authenticationSectionRoute,
  authenticationGroupsRoute,
  passSafeSettingsRoute,
  passSafeSettingsShortRoute,
  downloadAgentSettingsRoute,
  agentReleasesSettingsRoute,
  auditIndexRoute,
  auditTypeRoute,
  serviceProvidersRoute,
  rustdeskSettingsRoute,
  rustdeskServersSettingsRoute,
  catalogSettingsRoute,
  autonomySettingsRoute,
  deskConsoleRoute,
  deskBoardRoute,
  agentInstallSettingsRoute,
  connectionQualitySettingsRoute,
  floorPlansSettingsRoute,
  floorPlanSettingsRoute,
  remoteConnectSettingsRoute,
  rustdeskLaunchRoute,
  rustdeskLaunchNoTicketRoute,
  apiIntegrationSettingsRoute,
  webhooksSettingsRoute,
  apiLogSettingsRoute,
  aiAgentCompanySettingsRoute,
  aiAgentSettingsRoute,
  opteemumWorkstationsRoute,
  opteemumServersRoute,
  opteemumMobilesRoute,
  opteemumInactiveRoute,
  opteemumLiveRoute,
  opteemumDashboardRoute,
  opteemumUnassignedRoute,
  opteemumApplicationsRoute,
  opteemumScheduleRoute,
  opteemumRemoteRoute,
  opteemumRemoteSessionsRoute,
  opteemumDeviceRoute,
  opteemumSettingsIndexRoute,
  opteemumSettingsTabRoute,
  diagnosticReportsIndexRoute,
  diagnosticReportsPageRoute,
  softseeDashboardRoute,
  softseePageRoute,
  securiteeIndexRoute,
  securiteeDevicesRoute,
  securiteeDeviceRoute,
  securiteeEventsRoute,
  securiteeDetectionsRoute,
  securiteeEdrEventsRoute,
  securiteeIncidentsRoute,
  securiteeGravityZoneRoute,
  securiteeAdAccountsRoute,
  securiteeLocalAccountsRoute,
  securiteeEmailDomainsRoute,
  securiteeNetworkChecksRoute,
  securiteeXdrSettingsRoute,
  securiteeDashboardRoute,
  protecteeIndexRoute,
  protecteeDevicesRoute,
  protecteeDashboardRoute,
  printeengIndexRoute,
  printeengDashboardRoute,
  printeengDevicesRoute,
  printeengPrintersRoute,
  printeengEventsRoute,
  saveenergeeIndexRoute,
  saveenergeeDashboardRoute,
  saveenergeeDevicesRoute,
  saveenergeeEventsRoute,
  productiviteeIndexRoute,
  productiviteeDashboardRoute,
  productiviteeDevicesRoute,
  productiviteeUsersRoute,
  productiviteeUsersPeriodRoute,
  productiviteeManagementRoute,
  productiviteeDayReportRoute,
  softseeDeviceBareRoute,
  softseeDeviceRoute,
  softseeSettingsIndexRoute,
  softseeSettingsTabRoute,
  securiteeSettingsIndexRoute,
  securiteeSettingsTabRoute,
  printeengSettingsIndexRoute,
  printeengSettingsTabRoute,
  protecteeSettingsIndexRoute,
  protecteeSettingsTabRoute,
  saveenergeeSettingsIndexRoute,
  saveenergeeSettingsTabRoute,
  productiviteeSettingsIndexRoute,
  productiviteeSettingsTabRoute,
  telemetrySettingsRoute,
  discoverySetupSettingsRoute,
  vaultSettingsRoute,
  scanRulesSettingsRoute,
  proactiviteeSettingsIndexRoute,
  proactiviteeSettingsTabRoute,
  settingsAlarmsNewProactiviteeRoute,
  overviewTodayRoute,
  overviewAheadRoute,
  overviewItilRoute,
  overviewDomainsRoute,
  applicationsRoute,
  applicationMapRoute,
  applicationVendorsRoute,
  applicationMonthlyReportRoute,
  applicationDetailRoute,
  cmdbListRoute,
  cmdbHealthRoute,
  cmdbRecordRoute,
  cmdbImportRoute,
  cmdbBaselinesRoute,
  cmdbBaselineCompareRoute,
  maintenanceRoute,
  maintenanceCalendarRoute,
  maintenanceDayRoute,
  changeProposalsRoute,
  overviewNis2Route,
  problemsRoute,
  problemPatternsRoute,
  problemRecordRoute,
  overviewRoute,
  proactiviteeAlarmsRoute,
  proactiviteeDeviceIdRoute,
  proactiviteeDeviceRoute,
  proactiviteeDashboardRoute,
  dashboardsOnsitePresenceRoute,
  proactiviteeSnmpDashboardRoute,
  proactiviteeSnmpServicesRoute,
  proactiviteeSnmpHostsRoute,
  proactiviteeCoreApplicationsRoute,
  proactiviteeCoreApplicationsDashboardRoute,
  proactiviteeApplicationsDashboardRoute,
  proactiviteePageRoute,
  dashboardRoute,
  dashboardBoardRoute,
  dashboardModuleRoute,
  dashboardWallRoute,
  monitorWallboardRoute,
  alarmsRoute,
  admDashboardRoute,
  admPendingRoute,
  admExposureRoute,
  admMapRoute,
  admWallboardsRoute,
  admImpactRoute,
  assistantActivityRoute,
  assistantSchedulesRoute,
  admErrorsRoute,
  admErrorDetailRoute,
  admCoverageRoute,
  reportsRoute.addChildren([reportsSavedRoute, reportsSavedEditRoute]),
  admRunsRoute,
  admRunRoute,
  admSchedulesRoute,
  admChangesRoute,
  admSoftwarePendingRoute,
  admSoftwareCategoriesRoute,
  admChangesScopeRoute,
])

export function makeRouter() {
  return createRouter({ routeTree, basepath: '/app', defaultPreload: 'intent' })
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof makeRouter>
  }
}
